import { playClip, trimSoundBar } from "../../../Utils/soundTrim";
import { repairVoiceAudio } from "../../../Utils/voiceAudio";
import { assetUrl } from "../../../Utils/assetUrl";
import { trimVoiceBar, voiceStartPx, voiceTrimLabel } from "../../../Utils/voiceBarTrim";
import React, { useState, useEffect, useContext, useRef } from "react";
import { Rnd } from "react-rnd";
import Draggable from "react-draggable";
import Lottie from "lottie-web";
//import worker from './Worker'
//import CreateWorker from "./CreateWorker";
import ProjectContext from "../../../context/ProjectContext";
import MyContext from "../../../context/MyContext";
import TickerContext from "../../../context/ticker";
import AuthContext from "../../../context/userAuth.context";
import swal from "sweetalert";
import { Tooltip } from "react-tippy";
import zIndex from "@mui/material/styles/zIndex";
/** True when a character's talking mouth (Mouth_Talk) is showing, wherever the file keeps it. */
function mouthIsTalking(json) {
  const layerLists = [json.layers || []];
  (json.assets || []).forEach((a) => a && a.layers && layerLists.push(a.layers));
  for (const list of layerLists) {
    for (const layer of list) {
      if (!layer) continue;
      if (layer.nm === "Mouth_Talk" && !layer.hd) return true;
      // Some characters keep the mouths one level down, in a "Mouth_Comp" layer.
      if (layer.nm === "Mouth_Comp" && Array.isArray(layer.layers)) {
        if (layer.layers.some((y) => y && y.nm === "Mouth_Talk" && !y.hd)) return true;
      }
    }
  }
  return false;
}
function msToTime(duration) {
  var seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return minutes + ":" + seconds;
}
function msToTime2(duration) {
  var seconds = (duration / 1000) % 60,
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return minutes + ":" + seconds;
}
function getScaleUnitArray(count) {
  let arr = [];
  for (let i = 0; i < count; i++) {
    arr.push(i);
  }
  return arr;
}

const Aux = (props) => {
  return props.children;
};

const ScaleUnits = ({ count, perUnitMS, unitWidth }) => {
  var style = {
    marginRight: unitWidth,
  };

  useEffect(() => {
    style = {
      marginRight: unitWidth,
    };
  }, []);

  return count.map((val, index) => {
    return index === 0 ? (
      <Aux key={val}>
        <span
          className="scaleUnit"
          data-unit={index * perUnitMS}
          style={style}
        ></span>
        <span className="unit" style={style}></span>
        <span className="unit" style={style}></span>
        <span className="unit" style={style}></span>
      </Aux>
    ) : (
      <Aux key={index}>
        <span
          className="scaleUnit"
          data-unit={msToTime(index * perUnitMS)}
          style={style}
        ></span>
        <span className="unit" style={style}></span>
        <span className="unit" style={style}></span>
        <span className="unit" style={style}></span>
        {count.length - 1 === index && (
          <span
            className="scaleUnit"
            data-unit={msToTime((index + 1) * perUnitMS)}
            style={style}
          ></span>
        )}
      </Aux>
    );
  });
};

var Ids,
  Timer = 0,
  StartPoint;
var TickerPlay = null;
var startval = null;

export const Timeline = (props) => {
  const T_parent = useRef();
  const Scroll = useRef();
  const [standingJSON, setStandingJSON] = useState("");

  const {
    setTickerPosition,
    TickerPosition,
    setTickerStart,
    ReverseLayer,
    setClick_TickerPosition,
    TickerRef,
    TickerState,
    setTickerState,
  } = useContext(TickerContext);

  const {
    Tl_TotalTime,
    CanvasDisplay,
    setCanvasDisplay,
    timelineZoomVal,
    setLayersData,
    LayersData,
    setTl_TotalTime,
    Previous_Tl_TotalTime,
    setPrevious_TlTotalTime,
    setChangeCount,
    calculateTimeByWidth,
    calculateWidthByDuration,
    TimelineWidth,
    scaleLength,
    onePxEquivalent,
    clone,
    setRedoLayer,
    UndoLayer,
    setUndoLayer,
    ChangeCount,
    isPlayClicked,
    setIsPlayClicked,
    Backgrounds,
    VideoPlayerRef,
    EditorZoom,
    checkFunction,
    lottieRef,
    CharacterRef,
    seteditableObject,
  } = useContext(MyContext);
  // Live "is the video playing" for code that runs from older renders (the play loop, the mouth
  // switch). The isPlayClicked value those closures hold can be out of date by a frame or more.
  const playingRef = useRef(false);
  playingRef.current = !!isPlayClicked;

  const { slides, setslides } = useContext(ProjectContext);
  const { authenticationData } = useContext(AuthContext);
  const [VideoLoaded, setVideoLoaded] = useState(false);
  const videoref = useRef(null);
  const [CurrTime, setCurrTime] = useState(0);
  const [SoundPlaying, setSoundPlaying] = useState(false);
  const [TalkingCharacter, setTalkingCharacter] = useState(false);
  const [CurrentFrame, setCurrentFrame] = useState(0);
  const [Player, setPlayer] = useState(false);

  useEffect(() => {
    if (!CanvasDisplay) {
      setCanvasDisplay(true);
    }
    Timer = 0;
    // setTickerPosition(1);
    // setTickerState(1);
  }, [slides]);

  // useEffect(() => {

  //   // if(!isPlayClicked)
  //   LayersData.map(value =>{
  //     if(value.type.toLowerCase() == "character" && value.TTSName != "" && value.TTSName)
  //     {
  //         stopTalking(value.JSONValue, value)
  //     }

  //   })
  // }, [LayersData])

  useEffect(() => {
    const array = Array.from(slides);
    // debugger
    let change = false;
    for (let i = 0; i < array.length; i++) {
      if (array[i].IsActive) {
        if (Backgrounds.type) {
          array[i].SlideBackground = Backgrounds;
          array[i].LayerData = LayersData;
          change = true;
        } 
      }
    }

    if (change) {
      setslides(array);
    }
  }, [Backgrounds]);

  useEffect(() => {
    if (timelineZoomVal != null) {
      Scroll.current.scrollTo(TickerState - 20, 0);
    }
  }, [timelineZoomVal]);

  let start, previousTimeStamp;

  const checkTextLoaded = () => {
    const array = Array.from(LayersData);
    let totalTextsCount = 0,
      totalLoadedTextsCount = 0;
    for (let i = 0; i < array.length; i++) {
      if (array[i].type == "text" && array[i].opc == 1) {
        totalTextsCount++;
        let text = document.getElementById("Text-" + array[i].AnimationId);
        if (text) {
          totalLoadedTextsCount++;
        }
      }
    }
    if (totalTextsCount != 0 && totalTextsCount != totalLoadedTextsCount) {
      setTimeout(() => {
        checkTextLoaded();
      }, 100);
    } else if (totalTextsCount == totalLoadedTextsCount) {
      return true;
    }
  };

  const [myjson, setmyjson] = useState();
  const [LottiePlayer, setLottiePlayer] = useState(null);
  const [LottiePlayerAutoPlay, setLottiePlayerAutoPlay] = useState(true);

  useEffect(() => {
    if (!CanvasDisplay) {
      if (Tl_TotalTime.width > TickerState) {
        //setPlaying(true)

        const array = Array.from(LayersData);

        for (let i = 0; i < array.length; i++) {
          array[i].OutClass = "";
          array[i].InClass = "";
          if (array[i].Editable == true) {
            array[i].Editable = false;
            array[i].showDiv = false;
          }

          if (array[i].type == "text") {
            array[i].lock = false;
            array[i].edit = "false";
          }
          if (array[i].type == "Props") {
            array[i].lock = false;
            array[i].edit = "false";
          }
          if (array[i].type == "Shape") {
            array[i].lock = false;
            array[i].edit = "false";
          }
          if (array[i].type == "basicShape") {
            array[i].lock = false;
            array[i].edit = "false";
          }
          if (array[i].type == "Image") {
            array[i].lock = false;
            array[i].opc = 1;
          }
          if (array[i].type == "Video") {
            array[i].lock = false;
            array[i].opc = 1;
          }
          if (array[i].type == "Character") {
            array[i].isPlaying = false;
            array[i].lock = false;
            array[i].edit = "false";
            // setIsPlayClicked(true)
          }
        }

        setLayersData(array);

        let test = checkTextLoaded();
        if (test) {
          start = null;
          TickerPlay = TickerState;

          const id = window.requestAnimationFrame(step);
          Ids = id;
        }

        //workingWorker = new CreateWorker(worker);
        // workingWorker.postMessage({
        //   status: 'start',
        //   timer: onePxEquivalent,
        //   startTime: TickerPosition,
        //   endTime: Tl_TotalTime.width,
        // });
      }
    } else if (CanvasDisplay) {
      start = null;
      // workingWorker.postMessage({
      //   status: 'stop'
      // });
      // workingWorker.terminate();
      //workingWorker.postMessage('stop');
      //workingWorker.terminate();

      setIsPlayClicked(false);
      const array = Array.from(LayersData);

      for (let i = 0; i < array.length; i++) {
        array[i].endTimeOfAnimatedText = undefined;
        if (array[i].player) {
          array[i].player = false;
          if (array[i].type !== "audio") {
            showAsset(`Outer-${array[i].AnimationId}`);
          } else {
            const _Sound = document.getElementById(
              "Timelineaudio" + array[i].AnimationId
            );
            if (_Sound) {
              if (!_Sound.isPaused) {
                _Sound.pause();
              }
            }

            if (SoundPlaying) setSoundPlaying(false);
          }
        }
        if (array[i].startAtoZ) {
          array[i].startAtoZ = false;
        }
        if (array[i].Animate) {
          array[i].Animate = false;
          // startAgainLottie(array[i])
        }

        if (array[i].type == "Character") {
          // array[i].isPlaying = true;
          setIsPlayClicked(false);
          // setIsPlayClicked(true)
        }

        if (array[i].layerlock) {
          array[i].lock = true;
        }

        // if (array[i].type == 'Character') {
        //   if (array[i].x != array[i].AzData.x) {
        //     array[i].x = array[i].AzData.x;
        //   }
        //   if (array[i].y != array[i].AzData.y) {
        //     array[i].y = array[i].AzData.y;
        //   }
        //   if (array[i].width != array[i].AzData.width) {
        //     array[i].width = array[i].AzData.width;
        //   }
        //   if (array[i].height != array[i].AzData.height) {
        //     array[i].height = array[i].AzData.height;
        //   }
        //   if (array[i].rotateAngle != array[i].AzData.rotateAngle) {
        //     array[i].rotateAngle = array[i].AzData.rotateAngle;
        //   }
        // }
      }
      setLayersData(array);

      let width;
      let trans = TickerRef.current.style.transform;
      if (trans != "") {
        trans = trans.split("(");
        trans = trans[1].split(",");
        trans = trans[0].split("px");
        trans = eval(trans[0]);
        width = trans;
      } else {
        width = 0;
      }
      setTickerPosition(width);
      setTickerState(width);
      mtrans(width);

      Timer = width;
      if (Ids != null) {
        window.cancelAnimationFrame(Ids);
        Ids = null;
      }
    }
  }, [CanvasDisplay]);

  useEffect(() => {
    // const array = Array.from(LayersData)
    const _slides = Array.from(slides);
    _slides.map((value, index) => {
      if (!value.scaleEnd) {
        value.scaleEnd = value.offsetWidth ? value.offsetWidth : 1160;
      }

      if (!value.isSlideHeader) {
        if (value.IsActive) {
          value.onePxEquivalent = onePxEquivalent;
          if (value.isResized) {
            value.isResized = false;
            if (Previous_Tl_TotalTime.width != value.scaleEnd) {
              // value.startBackground = Previous_Tl_TotalTime.width
              const _value = _slides.find((x) => x.key == value.key + 1);

              value.endBackground = value.startBackground + value.offsetWidth;
              value.TotalSlideWidth = value.offsetWidth;
              if (_value) {
                _value.startBackground = value.endBackground;
              }
            }
          } else {
            setPrevious_TlTotalTime({
              width: value.scaleEnd,
              time: value.TotalLength,
            });
            if (_slides.length === 1) {
              if (value.endBackground != value.scaleEnd) {
                value.startBackground = 0;
                value.endBackground = value.scaleEnd;
                value.TotalSlideWidth = value.scaleEnd;
              }
            } else if (_slides.length > 1) {
              var _value = _slides.find((x) => x.key == value.key - 1);
              // value.startBackground = Previous_value.scaleEnd

              if (_value) {
                value.startBackground = _value.endBackground;
                value.endBackground = value.scaleEnd + _value.endBackground;
                value.TotalSlideWidth = value.scaleEnd;
              }
              // else
              // {
              //   value.endBackground = Tl_TotalTime.width
              // }
            }
          }
        }
        value.isSlideHeader = false;
      }
      value.isSlideHeader = false;
    });

    _slides.map((value2, index2) => {
      const _value2 = _slides[index2 - 1];
      if (_value2) {
        if (value2.ExtendToAllSlide) {
          value2.LayerData.map((layer_value) => {
            if (layer_value.type === "audio" && layer_value.ExtendToAllSlide) {
              layer_value.startSound = _value2.endBackground;
            }
          });
          value2.ExtendToAllSlide = false;
        }

        value2.startBackground = _value2.endBackground;
        value2.endBackground = value2.startBackground + value2.scaleEnd;
      } else {
        if (value2.ExtendToAllSlide) {
          value2.LayerData.map((layer_value) => {
            if (layer_value.type === "audio" && layer_value.ExtendToAllSlide) {
              layer_value.startSound = 0;
            }
          });
          value2.ExtendToAllSlide = false;
        }

        value2.startBackground = 0;
        value2.endBackground = value2.scaleEnd;
      }
    });

    // console.log("_slides");
    // console.log(_slides);

    // const _array = Array.from(LayersData);

    // _array.map((value, index) =>{

    //   // value.isChanged = false;
    // })
  }, [LayersData, Tl_TotalTime.width]);

  let istts = "pause";
  let oldjson;
  var executed = true;
  var executed2 = 1;

  const deepCompare = (arg1, arg2) => {
    if (
      Object.prototype.toString.call(arg1) ===
      Object.prototype.toString.call(arg2)
    ) {
      if (
        Object.prototype.toString.call(arg1) === "[object Object]" ||
        Object.prototype.toString.call(arg1) === "[object Array]"
      ) {
        if (Object.keys(arg1).length !== Object.keys(arg2).length) {
          return false;
        }
        return Object.keys(arg1).every(function (key) {
          return deepCompare(arg1[key], arg2[key]);
        });
      }
      return arg1 === arg2;
    }

    return false;
  };

  const showAsset = (id) => {
    const _asset = document.getElementById(id);
    if (_asset) _asset.style.display = "inline-block";
    return;
  };

  const hideAsset = (id) => {
    const _asset = document.getElementById(id);
    if (_asset) _asset.style.display = "none";
    return;
  };

  // this useEffect is use only for Animated Text, it is use when Animated Text is added in canvas
  useEffect(() => {
    console.log('123234 i am here', 123234)
    LayersData.map((value, index) => {
      if (value.type != undefined && value.type === "AnimatedText") {
        if (value.Added || value.NewAdded) {
          lottiePlayer(value, true);
          value.Added = false;
          value.NewAdded = false;
        }
      } else if (
        value.type != undefined &&
        value.type.toLowerCase() === "props"
      ) {
        if (value.Added) {
          lottiePlayerForProps(value);
          value.Added = false;
        }
      }
    });
  }, [LayersData]);

  let GlobalLottiePlayer = null;
  // set time of Audio and Video
  useEffect(() => {
    const array = Array.from(LayersData);
    array.map(async (value) => {
      if (value.type == "audio") {
        // if (value.player) {
        if (!isPlayClicked) {
          await AudioStop(value);
        }
      } else if (value.type === "Video") {
        const _VideoPlayer = document.getElementById(
          "Video-" + value.AnimationId
        );
        _VideoPlayer.volume = value.volume;
        if (SoundPlaying && isPlayClicked) {
          if (
            value.startPositionOnTimeline <= TickerPosition &&
            value.startPositionOnTimeline + value.widthOnTimeline >=
              TickerPosition
          ) {
            let ms =
              (TickerPosition - value.startPositionOnTimeline) *
              onePxEquivalent;
            var sec = (ms / 1000).toFixed(1);
            if (_VideoPlayer) {
              _VideoPlayer.currentTime = sec;
              _VideoPlayer.play();
            }
          }
        } else {
          if (_VideoPlayer) _VideoPlayer.pause();
        }
      }
      if (isPlayClicked) {
        if (value.type.toLowerCase() === "basicshape") {
          const _OuterDiv = document.getElementById(
            "Outer-" + value.AnimationId
          );
          if (_OuterDiv) {
            _OuterDiv.style.transform = `rotate(${value.rotateAngle}deg)`;
          }
        } else if (value.type.toLowerCase() === "character") {
          const _lottieValue = await ForEmergencyLottiePlayer(value);
          if (_lottieValue) {
            _lottieValue.goToAndPlay(0, true);
          }
        } else if (value.type.toLowerCase() === "props") {
          const _value = await ForEmergencyLottiePlayer(value);
          if (_value)
            _value.goToAndPlay(
              value.CurrentFrame ? value.CurrentFrame : _value.currentFrame,
              true
            );
        }

        // if (value.type !== "Props") {
        //   if (value.Animate) {
        //     startAgainLottie(value);
        //   }
        // } else
        if (value.type === "AnimatedText") {
          value.DrapEndAnimatedText = true;

          const _value = await ForEmergencyLottiePlayer(value);
          if (_value)
            _value.goToAndStop(
              _value.totalFrames - 300,
              true,
              value.AnimationId
            );
        }
        // else {
        //   startAgainLottie(value);
        // }
      } else {
        if (value.type === "audio") {
          AudioStop(value);
        }

        if (value.type.toLowerCase() === "basicshape") {
          const _OuterDiv = document.getElementById(
            "Outer-" + value.AnimationId
          );
          if (_OuterDiv) {
            _OuterDiv.style.transform = `rotate(${value.rotateAngle}deg)`;
          }
        } else if (value.type.toLowerCase() === "props") {
          const _value = await ForEmergencyLottiePlayer(value);
          if (_value)
            _value.goToAndStop(
              value.CurrentFrame
                ? value.CurrentFrame - 50
                : _value.currentFrame - 50,
              true
            );
        }

        if (value.type === "AnimatedText") {
          const _value = await ForEmergencyLottiePlayer(value);
          if (_value)
            _value.goToAndStop(
              _value.totalFrames - 300,
              true,
              value.AnimationId
            );
        } else if (value.type.toLowerCase() === "character") {
          // Stopped while the character was speaking: silence the voice and close the mouth.
          // (The voice and mouth were only switched off at the ends of the voice block, so
          // stopping in the middle left the mouth moving.) Play again resumes both in step.
          if (value.TTSName) {
            if (value.Audio instanceof HTMLMediaElement && !value.Audio.paused) {
              value.Audio.pause();
            }
            value.isPlaying = false;
            if (value.JSONValue && mouthIsTalking(value.JSONValue)) {
              value.isStopTalkingInTimeline = true;
              stopTalking(value.JSONValue, value);
            }
          }
        }
      }
    });
  }, [SoundPlaying, isPlayClicked]);

  // Play head position on the timeline in px (read live while sounds play).
  const tickerPx = () => {
    const t = TickerRef.current && TickerRef.current.style.transform;
    const m = /translate\(\s*(-?[\d.]+)px/.exec(t || "");
    return m ? parseFloat(m[1]) : 0;
  };

  // audio start
  const AudioStart = (value, count, isPlayClicked, loop) => {
    if (!value.Sound || value.Sound.paused === undefined) {
      value.Sound = new Audio(authenticationData.ApiBaseURL + "/" + value.path);
    }

    if (value.Sound) {
      if (value.Sound.paused) {
        if (!loop) {
          // Trimmed clip (startSound = where it starts in the file), loop and fades: same rules
          // as the export (Utils/soundTrim.js).
          if (count > value.startPositionOnTimeline) {
            const pxMs = onePxEquivalent;
            if (value.__stopFade) value.__stopFade();
            if (isPlayClicked) value.__stopFade = playClip(value.Sound, {
              offsetSec: ((Number(value.startSound) || 0) * pxMs) / 1000,
              sec: ((count - value.startPositionOnTimeline) * pxMs) / 1000,
              clipSec: ((Number(value.widthOnTimeline) || 0) * pxMs) / 1000,
              // "Loop" repeats the clip after its bar ends (handled by the caller), not the file.
              loop: false,
              // "Lower while characters speak" (Utils/ducking.js)
              duck: value.duckUnderVoices ? () => window.__toonsDuckFactor || 1 : null,
              fadeIn: value.fadeIn,
              fadeOut: value.fadeOut,
              volume: (value.volume === null || value.volume === undefined || value.volume === "" ? 100 : Number(value.volume)) / 100,
              secNow: () => ((tickerPx() - value.startPositionOnTimeline) * pxMs) / 1000,
            });
            value.Sound.onended = function () {
              value.Sound.pause();
            };
          }
        } else {
          // "Loop": the clip plays again after its bar ends (each repeat starts at
          // startSoundValue on the timeline), with the same trim and fades.
          const pxMs = onePxEquivalent;
          const repeatStart =
            Number(value.startSoundValue) || Number(value.startPositionOnTimeline) || 0;
          if (value.__stopFade) value.__stopFade();
          if (isPlayClicked) value.__stopFade = playClip(value.Sound, {
            offsetSec: ((Number(value.startSound) || 0) * pxMs) / 1000,
            sec: (Math.max(0, count - repeatStart) * pxMs) / 1000,
            clipSec: ((Number(value.widthOnTimeline) || 0) * pxMs) / 1000,
            loop: false,
            duck: value.duckUnderVoices ? () => window.__toonsDuckFactor || 1 : null,
            fadeIn: value.fadeIn,
            fadeOut: value.fadeOut,
            volume: (value.volume === null || value.volume === undefined || value.volume === "" ? 100 : Number(value.volume)) / 100,
            secNow: () => ((tickerPx() - repeatStart) * pxMs) / 1000,
          });
        }
      }
    }

    return;
  };

  //Get Seconds from TimeStamp String
  function convertHMS(timeString) {
    const arr = timeString.split(":");
    const seconds = arr[0] * 3600 + arr[1] * 60 + +arr[2] + +arr[3] / 1000;
    return seconds;
  }

  // audio stop
  const AudioStop = (value) => {
    if (!value.Sound || value.Sound.paused === undefined) {
      value.Sound = new Audio(authenticationData.ApiBaseURL + "/" + value.path);
    }

    if (value.Sound) {
      if (!value.Sound.paused) {
        if (value.Sound.pause) {
          setTimeout(() => {
            value.Sound.pause();
          }, 200);
        }
      }
    }
    if (value.startMusic) {
      value.startMusic = false;

      // change = true;
    }

    return;
  };

  //Doing this to fix jerk on Start from Play
  useEffect(() => {
    if (checkFunction === true) {
      Check(0);
    }
  }, [checkFunction]);

  const resetOpacity = (value) => {
    const _Outerasset = document.getElementById(`Outer-${value.AnimationId}`);
    if (_Outerasset) {
      _Outerasset.style.opacity = value.originalOpacity;
    }
  };
  let isStartLottiePlayer = false;
  const Check = async (count) => {
    const array = Array.from(LayersData);
    repairVoiceAudio(array, authenticationData.ApiBaseURL);
    let change = false;

    //call no of times characters are present on canvas
    for (let i = 0; i < array.length; i++) {
      if (TickerPlay === Tl_TotalTime.width) {
        setIsPlayClicked(false);
        // change = true;
      }

      if (!isStartLottiePlayer) {
        if (!array[i].TTSName) {
          if (
            array[i].type !== "Props" &&
            array[i].type !== "AnimatedText" &&
            array[i].type !== "Character"
          ) {
            array[i].LoadLottie = false;
            lottiePlayer(array[i]);
          } else if (
            array[i].type !== "AnimatedText" &&
            array[i].type !== "Character"
          ) {
            lottiePlayerForProps(array[i]);
          }
          // isStartLottiePlayer = true;
        }
      }

      if (array.length - 1 === i) {
        if (!isStartLottiePlayer) {
          isStartLottiePlayer = true;
        }
      }

      if (isPlayClicked == false && array[i].Audio) {
        array[i].Audio.pause();
      }

      if (count === Tl_TotalTime.width) {
        // if(LottiePlayer)
        // {
        //   LottiePlayer.goToAndStop(0, true, array[i].AnimationId);
        // }
      }

      var _StartPositionOnTimeline;

      if (
        array[i].type == "Character" ||
        array[i].type === "AnimatedText" ||
        array[i].type == "audio"
      ) {
        if (array[i].LastStartPositionOnTimeline === undefined) {
          _StartPositionOnTimeline = array[i].startPositionOnTimeline;
          array[i]._StartPositionOnTimeline = array[i].startPositionOnTimeline;
        } else {
          _StartPositionOnTimeline = array[i].LastStartPositionOnTimeline;
          array[i]._StartPositionOnTimeline =
            array[i].LastStartPositionOnTimeline;
        }
      } else {
        _StartPositionOnTimeline = array[i].startPositionOnTimeline;
      }

      if (array[i].type == "AnimatedText") {
        if (_StartPositionOnTimeline - 5 < count) {
          array[i].LoadLottie = false;
        }

        if (_StartPositionOnTimeline <= count) {
          array[i].DrapEndAnimatedText = false;
          if (count < _StartPositionOnTimeline + 10) {
            if (!array[i].LoadLottie) {
              array[i].LoadLottie = true;
              lottiePlayer(array[i]);
            }
          }

          if (
            Tl_TotalTime.width == count &&
            Tl_TotalTime.width == array[i].widthOnTimeline
          ) {
            array[i].DrapEndAnimatedText = true;
            array[i].LoadLottie = false;
            const _value = ForEmergencyLottiePlayer(array[i]);
            if (_value) _value.goToAndStop(_value.totalFrames - 200, true);
            // change = true;
          } else {
            if (array[i].DrapEndAnimatedText) {
              array[i].DrapEndAnimatedText = false;
            }
          }

          if (array[i].widthOnTimeline >= 465) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 225 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              // 225
              if (!array[i].endTimeOfAnimatedText) {
                // change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].playSegmentFrom = 480;
                array[i].playSegmentTo = 600;

                const _value = await ForEmergencyLottiePlayer(array[i]);
                if (_value) {
                  _value.goToAndPlay(480, true, array[i].AnimationId);
                }
              }
            }
          } else if (
            array[i].widthOnTimeline > 349 &&
            array[i].widthOnTimeline < 465
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 200 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                // change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 480;
                array[i].playSegmentTo = 600;

                const _value = await ForEmergencyLottiePlayer(array[i]);
                if (_value) {
                  _value.playSegments(
                    [array[i].playSegmentFrom, array[i].playSegmentTo],
                    true
                  );
                }
              }
            }
          } else if (
            array[i].widthOnTimeline > 225 &&
            array[i].widthOnTimeline < 349
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 175 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                // change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 505;
                array[i].playSegmentTo = 600;
                const _value = await ForEmergencyLottiePlayer(array[i]);
                if (_value) {
                  _value.playSegments(
                    [array[i].playSegmentFrom, array[i].playSegmentTo],
                    true
                  );
                }
              }
            }
          } else if (
            array[i].widthOnTimeline > 117 &&
            array[i].widthOnTimeline < 233
          ) {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 100 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                // change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = true;
                array[i].fastspeedOn = false;
                array[i].playSegmentFrom = 460;
                array[i].playSegmentTo = 600;
                const _value = await ForEmergencyLottiePlayer(array[i]);
                if (_value) {
                  _value.setSpeed(2.5);
                  _value.playSegments(
                    [array[i].playSegmentFrom, array[i].playSegmentTo],
                    true
                  );
                }
              }
            }
          } else {
            if (
              count >=
                array[i].widthOnTimeline + _StartPositionOnTimeline - 50 &&
              array[i].endTimeOfAnimatedText == undefined
            ) {
              if (!array[i].endTimeOfAnimatedText) {
                // change = true;
                array[i].endTimeOfAnimatedText = true;
                array[i].speedOn = false;
                array[i].fastspeedOn = true;
                array[i].playSegmentFrom = 520;
                array[i].playSegmentTo = 600;
                const _value = await ForEmergencyLottiePlayer(array[i]);
                if (_value) {
                  _value.setSpeed(3);
                  _value.playSegments(
                    [array[i].playSegmentFrom, array[i].playSegmentTo],
                    true
                  );
                }
              }
            }
          }
        } else if (_StartPositionOnTimeline - 5 < count) {
          array[i].LoadLottie = false;
        }
      } else if (array[i].type === "audio") {
        if (count == Tl_TotalTime.width) {
          AudioStop(array[i]);
        }

        if (array[i].widthOnTimeline >= Tl_TotalTime.width) {
          if (
            _StartPositionOnTimeline <= count &&
            _StartPositionOnTimeline + array[i].widthOnTimeline >= count &&
            count != Tl_TotalTime.width
          ) {
            await AudioStart(array[i], count, isPlayClicked, false);
          } else if (
            _StartPositionOnTimeline + array[i].widthOnTimeline < count &&
            count != Tl_TotalTime.width
          ) {
            if (array[i].loop) {
              await AudioStart(array[i], count, isPlayClicked, true);
            } else {
              await AudioStop(array[i]);
            }
          } else {
            await AudioStop(array[i]);
          }
        } else {
          if (
            _StartPositionOnTimeline <= count &&
            _StartPositionOnTimeline + array[i].widthOnTimeline >= count &&
            count !== Tl_TotalTime.width
          ) {
            await AudioStart(array[i], count, isPlayClicked, false);
          } else if (
            _StartPositionOnTimeline + array[i].widthOnTimeline <
            count
          ) {
            if (array[i].loop) {
              if (!array[i].changeStartValue) {
                await AudioStop(array[i]);
                array[i].startSoundValue = count;
                array[i].changeStartValue = true;
              }

              if (
                array[i].startSoundValue <= count &&
                array[i].startSoundValue + array[i].widthOnTimeline >= count &&
                count !== Tl_TotalTime.width
              ) {
                await AudioStart(array[i], count, isPlayClicked, true);
              } else {
                array[i].changeStartValue = false;
              }
            } else {
              await AudioStop(array[i]);
            }
          } else if (_StartPositionOnTimeline < count) {
            await AudioStop(array[i]);
          }
        }
      }

      let _mcount;
      if (array[i].InEffect !== "none") {
        if (array[i].InEffect === "animated slideInLeft " && isPlayClicked) {
          // This is fixed code for slideInLeft
          var totalwidth = 0 - array[i].width;

          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }

          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = Math.abs(startpoint * diff) + totalwidth;

            // check = true;
            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }
          }
        } else if (
          array[i].InEffect === "animated swipeInLeft " &&
          isPlayClicked
        ) {
          //Trying swipeInLeft
          var totalwidth = array[i].originalX - 10;

          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }

          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = Math.abs(startpoint * diff) + totalwidth;

            // check = true;
            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }

            //Fading in with Swipe Left
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = _mcount - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        } else if (
          array[i].InEffect === "animated slideInRight " &&
          isPlayClicked
        ) {
          //var totalwidth = array[i].originalX + array[i].width;
          var totalwidth =
            document.getElementsByClassName("EditorTrackInner")[0].clientWidth +
            10;
          //+10 is only for making it go outside the canvas completely.
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = totalwidth - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }
          }
        } else if (
          array[i].InEffect === "animated swipeInRight " &&
          isPlayClicked
        ) {
          //var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX + 10;
          //+10 is only for making it go outside the canvas completely.
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].x = totalwidth - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }

            //Fading in with Swipe Right
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = _mcount - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        } else if (
          array[i].InEffect === "animated slideInDown " &&
          isPlayClicked
        ) {
          var totalHeight =
            document.getElementsByClassName("EditorTrackInner")[0]
              .clientHeight + 10;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].y = totalHeight - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
          }
        } else if (
          array[i].InEffect === "animated swipeInDown " &&
          isPlayClicked
        ) {
          var totalHeight = array[i].originalY - 20;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
            _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            array[i].y = totalHeight - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
            //Fading in with Swipe
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = _mcount - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        } else if (
          array[i].InEffect === "animated slideInUp " &&
          isPlayClicked
        ) {
          var totalHeight = 0 - array[i].height;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount &&
            _mcount >= array[i].startPositionOnTimeline
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;

            array[i].y = totalHeight - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
          }

          // console.log("Position");
        } else if (
          array[i].InEffect === "animated swipeInUp " &&
          isPlayClicked
        ) {
          var totalHeight = array[i].originalY + 20;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount &&
            _mcount >= array[i].startPositionOnTimeline
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;

            array[i].y = totalHeight - startpoint * diff;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }

            //Fading in with Swipe Up
            let diff2 = totalHeight - array[i].originalY;
            diff2 = diff2 / array[i].startTransitionWidth;
            let startpoint2 = _mcount - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint2 / array[i].startTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }

          // console.log("Position");
        } else if (array[i].InEffect === "animated fadeIn " && isPlayClicked) {
          var totalHeight = array[i].originalX + array[i].height;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (
            _mcount > array[i].startPositionOnTimeline - 10 &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            let opacityPercentage = startpoint / array[i].startTransitionWidth;
            let _opacity = opacityPercentage;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }

            // const _Outerasset = document.getElementById(
            //   `OuterLoader-${array[i].AnimationId}`
            // );

            // if (array[i].type.toLowerCase() === "basicshape") {
            //   const _basicshape = document.getElementById(
            //     "default-shape-" + array[i].key
            //   );

            //   if (_basicshape && array[i].opacity >= _opacity) {
            //     _basicshape.style.opacity = _opacity;
            //   }
            // } else if (array[i].type.toLowerCase() === "image") {
            //   const _img = document.getElementById(
            //     "image-" + array[i].AnimationId
            //   );

            //   if (_img && array[i].opacity >= _opacity) {
            //     _img.style.opacity = _opacity;
            //   }
            // } else if (array[i].type.toLowerCase() === "video") {
            //   const _videoDiv = document.getElementById(
            //     "Video-" + array[i].AnimationId
            //   );
            //   if (_videoDiv) {
            //     _videoDiv.style.opacity = array[i].opacity;
            //   }
            // } else if (array[i].type.toLowerCase() === "props") {
            //   const _propsDiv = document.getElementById(
            //     "props-" + array[i].AnimationId
            //   );

            //   if (_propsDiv && array[i].opacity >= _opacity) {
            //     _propsDiv.style.opacity = _opacity;
            //   }
            // } else if (array[i].type === "text") {
            //   let _textDiv = document.getElementById(
            //     "Text-" + array[i].AnimationId
            //   );

            //   if (_textDiv && array[i].opacity >= _opacity) {
            //     _textDiv.style.opacity = _opacity;
            //   }
            // } else if (_Outerasset && array[i].opacity >= _opacity) {
            //   _Outerasset.style.opacity = _opacity;
            // }
          }
        }
        if (array[i].InEffect === "animated zoomIn " && isPlayClicked) {
          var totalHeight = array[i].originalX + array[i].originalHeight;
          if (
            count ==
            array[i].startPositionOnTimeline + array[i].startTransitionWidth + 1
          ) {
            _mcount =
              array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          } else {
            _mcount = count;
          }
          if (_mcount > 0 && _mcount < array[i].startPositionOnTimeline) {
            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset) {
              _Outerasset.style.transform = `rotate(${array[i].rotateAngle}deg) scale(0)`;
            }
          }
          if (
            _mcount >= array[i].startPositionOnTimeline &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].startTransitionWidth;
            let startpoint = _mcount - array[i].startPositionOnTimeline;
            let percentage = startpoint / array[i].startTransitionWidth;

            if (percentage > 0 && percentage <= 9) {
              const _Outerasset = document.getElementById(
                `Outer-${array[i].AnimationId}`
              );
              if (_Outerasset) {
                _Outerasset.style.transform = `rotate(${array[i].rotateAngle}deg) scale(${percentage})`;
              }
            }
            if (percentage > 9 && percentage <= 10) {
              const _Outerasset = document.getElementById(
                `Outer-${array[i].AnimationId}`
              );
              if (_Outerasset) {
                _Outerasset.style.transform = `rotate(${array[i].rotateAngle}deg) scale(1)`;
              }
            }

            // if (percentage >= 0) {
            //   array[i].width = percentage * array[i].originalWidth;
            //   array[i].height = percentage * array[i].originalHeight;
            //   array[i].x =
            //     array[i].originalX +
            //     (array[i].originalWidth - array[i].width) / 2;
            //   array[i].y =
            //     array[i].originalY +
            //     (array[i].originalHeight - array[i].height) / 2;
            //   if (array[i].type == "text") {
            //     array[i].fontSize = parseInt(
            //       array[i].originalFontSize * percentage
            //     );
            //   }

            //   const _Outerasset = document.getElementById(
            //     `Outer-${array[i].AnimationId}`
            //   );
            //   const _Innerasset = document.getElementById(
            //     `Inner-${array[i].AnimationId}`
            //   );

            //   if (array[i].type === "text") {
            //     let _textDiv = document.getElementById(
            //       "Text-" + array[i].AnimationId
            //     );
            //     _Outerasset.style.width =
            //       Math.round((array[i].width * EditorZoom) / 100) + "px";
            //     _Outerasset.style.height =
            //       Math.round((array[i].height * EditorZoom) / 100) + "px";
            //     _Outerasset.style.left =
            //       Math.round((array[i].x * EditorZoom) / 100) + "px";
            //     _Outerasset.style.top =
            //       Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     _Innerasset.style.width =
            //       Math.round((array[i].width * EditorZoom) / 100) + "px";
            //     _Innerasset.style.height =
            //       Math.round((array[i].height * EditorZoom) / 100) + "px";
            //     _Innerasset.style.left =
            //       Math.round((array[i].x * EditorZoom) / 100) + "px";
            //     _Innerasset.style.top =
            //       Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     _textDiv.style.width =
            //       Math.round((array[i].width * EditorZoom) / 100) + "px";
            //     _textDiv.style.height =
            //       Math.round((array[i].height * EditorZoom) / 100) + "px";
            //     _textDiv.style.left =
            //       Math.round((array[i].x * EditorZoom) / 100) + "px";
            //     _textDiv.style.top =
            //       Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     _textDiv.style.fontSize =
            //       Math.round((array[i].fontSize * EditorZoom) / 100) + "px";
            //   } else if (array[i].type.toLowerCase() === "basicshape") {
            //     if (_Outerasset) {
            //       _Outerasset.style.width =
            //         Math.round((array[i].width * EditorZoom) / 100) + "px";
            //       _Outerasset.style.height =
            //         Math.round((array[i].height * EditorZoom) / 100) + "px";
            //       _Outerasset.style.left =
            //         Math.round((array[i].x * EditorZoom) / 100) + "px";
            //       _Outerasset.style.top =
            //         Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     }
            //   } else if (array[i].type.toLowerCase() === "image") {
            //     const _img = document.getElementById(
            //       "image-" + array[i].AnimationId
            //     );

            //     if (_img) {
            //       _img.style.width =
            //         Math.round((array[i].width * EditorZoom) / 100) + "px";
            //       _img.style.height =
            //         Math.round((array[i].height * EditorZoom) / 100) + "px";
            //       _img.style.left =
            //         Math.round((array[i].x * EditorZoom) / 100) + "px";
            //       _img.style.top =
            //         Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     }
            //   } else if (array[i].type.toLowerCase() === "props") {
            //     if (_Outerasset) {
            //       _Outerasset.style.width =
            //         Math.round((array[i].width * EditorZoom) / 100) + "px";
            //       _Outerasset.style.height =
            //         Math.round((array[i].height * EditorZoom) / 100) + "px";
            //       _Outerasset.style.left =
            //         Math.round((array[i].x * EditorZoom) / 100) + "px";
            //       _Outerasset.style.top =
            //         Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     }
            //   } else if (array[i].type.toLowerCase() === "video") {
            //     const _videoDiv = document.getElementById(
            //       "Video-" + array[i].AnimationId
            //     );

            //     if (_videoDiv) {
            //       _videoDiv.style.width =
            //         Math.round((array[i].width * EditorZoom) / 100) + "px";
            //       _videoDiv.style.height =
            //         Math.round((array[i].height * EditorZoom) / 100) + "px";
            //       _videoDiv.style.left =
            //         Math.round((array[i].x * EditorZoom) / 100) + "px";
            //       _videoDiv.style.top =
            //         Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     }
            //   } else if (_Outerasset && _Innerasset) {
            //     _Outerasset.style.width =
            //       Math.round((array[i].width * EditorZoom) / 100) + "px";
            //     _Outerasset.style.height =
            //       Math.round((array[i].height * EditorZoom) / 100) + "px";
            //     _Outerasset.style.left =
            //       Math.round((array[i].x * EditorZoom) / 100) + "px";
            //     _Outerasset.style.top =
            //       Math.round((array[i].y * EditorZoom) / 100) + "px";
            //     _Innerasset.style.width =
            //       Math.round((array[i].width * EditorZoom) / 100) + "px";
            //     _Innerasset.style.height =
            //       Math.round((array[i].height * EditorZoom) / 100) + "px";
            //     _Innerasset.style.left =
            //       Math.round((array[i].x * EditorZoom) / 100) + "px";
            //     _Innerasset.style.top =
            //       Math.round((array[i].y * EditorZoom) / 100) + "px";
            //   }
            // }
            //array[i].opacity = opacityPercentage
            // check = true;
          }
        }
      }

      if (array[i].OutEffect !== "none") {
        if (array[i].OutEffect === "animated slideOutLeft " && isPlayClicked) {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = 0 - array[i].width;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }
          }
        }
        if (array[i].OutEffect === "animated swipeOutLeft " && isPlayClicked) {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX - 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }

            //Fade out with Swiping Left
            let TickerIncr = _mcount - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        }
        if (array[i].OutEffect === "animated slideOutRight " && isPlayClicked) {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth =
            document.getElementsByClassName("EditorTrackInner")[0].clientWidth +
            10;
          //+10 is only for making it go outside the canvas completely.
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            // let diff = array[i].width / array[i].endTransitionWidth;
            // let TickerIncr = _mcount - grandWidth;
            // array[i].x = array[i].originalX + diff * TickerIncr;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }
          }
        }
        if (array[i].OutEffect === "animated swipeOutRight " && isPlayClicked) {
          // var totalwidth = array[i].originalX + array[i].width;
          var totalwidth = array[i].originalX + 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalwidth - array[i].originalX;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;
            array[i].x = array[i].originalX + diff * startpoint;
            // let diff = array[i].width / array[i].endTransitionWidth;
            // let TickerIncr = _mcount - grandWidth;
            // array[i].x = array[i].originalX + diff * TickerIncr;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.left =
                Math.round((array[i].x * EditorZoom) / 100) + "px";
            }

            //Fade out with Swiping Right
            let TickerIncr = _mcount - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        }
        if (array[i].OutEffect === "animated slideOutUp " && isPlayClicked) {
          var totalHeight = 0 - array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
          }
          // else {
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutUp " && isPlayClicked) {
          var totalHeight = array[i].originalY - 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
            //Fade out with Swiping
            let TickerIncr = _mcount - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
        }
        if (array[i].OutEffect === "animated slideOutDown " && isPlayClicked) {
          var totalHeight =
            document.getElementsByClassName("EditorTrackInner")[0]
              .clientHeight + 10;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth + 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }
          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }
          }
          // else {
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated swipeOutDown " && isPlayClicked) {
          var totalHeight = array[i].originalY + 20;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth + 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }
          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let diff = totalHeight - array[i].originalY;
            diff = diff / array[i].endTransitionWidth;
            let startpoint = _mcount - grandWidth;

            array[i].y = array[i].originalY + diff * startpoint;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );

            if (_Outerasset) {
              _Outerasset.style.top =
                Math.round((array[i].y * EditorZoom) / 100) + "px";
            }

            //Fade out with Swiping
            let TickerIncr = _mcount - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
          }
          // else {
          //   array[i].y = array[i].originalY;
          // }
        }
        if (array[i].OutEffect === "animated fadeOut " && isPlayClicked) {
          var totalwidth = array[i].originalX + array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (grandWidth <= _mcount) {
            let TickerIncr = _mcount - grandWidth;
            let opacityPercentage =
              1 - TickerIncr / array[i].endTransitionWidth;
            let _opacity = opacityPercentage;

            const _Outerasset = document.getElementById(
              `Outer-${array[i].AnimationId}`
            );
            if (_Outerasset && array[i].opacity >= _opacity) {
              _Outerasset.style.opacity = _opacity;
            }
            //   const _Outerasset = document.getElementById(
            //     `OuterLoader-${array[i].AnimationId}`
            //   );

            //   if (array[i].type.toLowerCase() === "basicshape") {
            //     const _basicshape = document.getElementById(
            //       "default-shape-" + array[i].key
            //     );

            //     if (_basicshape && array[i].opacity >= _opacity) {
            //       _basicshape.style.opacity = _opacity;
            //     }
            //   } else if (array[i].type.toLowerCase() === "image") {
            //     const _img = document.getElementById(
            //       "image-" + array[i].AnimationId
            //     );

            //     if (_img && array[i].opacity >= _opacity) {
            //       _img.style.opacity = _opacity;
            //     }
            //   } else if (array[i].type.toLowerCase() === "video") {
            //     const _videoDiv = document.getElementById(
            //       "Video-" + array[i].AnimationId
            //     );
            //     if (_videoDiv && array[i].opacity >= _opacity) {
            //       _videoDiv.style.opacity = _opacity;
            //     }
            //   } else if (array[i].type.toLowerCase() === "props") {
            //     const _propsDiv = document.getElementById(
            //       "props-" + array[i].AnimationId
            //     );

            //     if (_propsDiv && array[i].opacity >= _opacity) {
            //       _propsDiv.style.opacity = _opacity;
            //     }
            //   } else if (array[i].type === "text") {
            //     let _textDiv = document.getElementById(
            //       "Text-" + array[i].AnimationId
            //     );
            //     if (_textDiv && array[i].opacity >= _opacity) {
            //       _textDiv.style.opacity = _opacity;
            //     }
            //   } else if (_Outerasset) {
            //     if (array[i].opacity >= _opacity)
            //       _Outerasset.style.opacity = _opacity;
            //   }
          }
          //else {
          //   array[i].opacity = array[i].originalOpacity;
          // }
        }
        if (array[i].OutEffect === "animated zoomOut ") {
          var totalwidth = array[i].originalX + array[i].height;
          let grandWidth =
            array[i].startPositionOnTimeline +
            (array[i].widthOnTimeline - array[i].endTransitionWidth);

          let _mcount;
          if (count == grandWidth - 1) {
            _mcount = grandWidth;
          } else {
            _mcount = count;
          }

          if (
            grandWidth <= _mcount &&
            array[i].startPositionOnTimeline + array[i].widthOnTimeline >=
              _mcount
          ) {
            let TickerIncr = _mcount - grandWidth;

            let percentage = 1 - TickerIncr / array[i].endTransitionWidth;
            if (percentage >= 0) {
              array[i].width = percentage * array[i].originalWidth;
              array[i].height = percentage * array[i].originalHeight;
              array[i].x =
                array[i].originalX +
                (array[i].originalWidth - array[i].width) / 2;
              array[i].y =
                array[i].originalY +
                (array[i].originalHeight - array[i].height) / 2;
              if (array[i].type == "text") {
                array[i].fontSize = parseInt(
                  array[i].originalFontSize * percentage
                );
              }

              const _Outerasset = document.getElementById(
                `Outer-${array[i].AnimationId}`
              );
              const _Innerasset = document.getElementById(
                `Inner-${array[i].AnimationId}`
              );

              if (array[i].type === "text") {
                let _textDiv = document.getElementById(
                  "Text-" + array[i].AnimationId
                );
                _Outerasset.style.width =
                  Math.round((array[i].width * EditorZoom) / 100) + "px";
                _Outerasset.style.height =
                  Math.round((array[i].height * EditorZoom) / 100) + "px";
                _Outerasset.style.left =
                  Math.round((array[i].x * EditorZoom) / 100) + "px";
                _Outerasset.style.top =
                  Math.round((array[i].y * EditorZoom) / 100) + "px";
                _Innerasset.style.width =
                  Math.round((array[i].width * EditorZoom) / 100) + "px";
                _Innerasset.style.height =
                  Math.round((array[i].height * EditorZoom) / 100) + "px";
                _Innerasset.style.left =
                  Math.round((array[i].x * EditorZoom) / 100) + "px";
                _Innerasset.style.top =
                  Math.round((array[i].y * EditorZoom) / 100) + "px";
                _textDiv.style.width =
                  Math.round((array[i].width * EditorZoom) / 100) + "px";
                _textDiv.style.height =
                  Math.round((array[i].height * EditorZoom) / 100) + "px";
                _textDiv.style.left =
                  Math.round((array[i].x * EditorZoom) / 100) + "px";
                _textDiv.style.top =
                  Math.round((array[i].y * EditorZoom) / 100) + "px";
                _textDiv.style.fontSize =
                  Math.round((array[i].fontSize * EditorZoom) / 100) + "px";
              } else if (array[i].type.toLowerCase() === "basicshape") {
                if (_Outerasset) {
                  _Outerasset.style.width =
                    Math.round((array[i].width * EditorZoom) / 150) + "px";
                  _Outerasset.style.height =
                    Math.round((array[i].height * EditorZoom) / 150) + "px";
                  _Outerasset.style.left =
                    Math.round((array[i].x * EditorZoom) / 100) + "px";
                  _Outerasset.style.top =
                    Math.round((array[i].y * EditorZoom) / 100) + "px";
                }
              } else if (array[i].type.toLowerCase() === "image") {
                const _img = document.getElementById(
                  "image-" + array[i].AnimationId
                );

                if (_img) {
                  _img.style.width =
                    Math.round((array[i].width * EditorZoom) / 100) + "px";
                  _img.style.height =
                    Math.round((array[i].height * EditorZoom) / 100) + "px";
                  _img.style.left =
                    Math.round((array[i].x * EditorZoom) / 100) + "px";
                  _img.style.top =
                    Math.round((array[i].y * EditorZoom) / 100) + "px";
                }
              } else if (array[i].type.toLowerCase() === "props") {
                if (_Outerasset) {
                  _Outerasset.style.width =
                    Math.round((array[i].width * EditorZoom) / 100) + "px";
                  _Outerasset.style.height =
                    Math.round((array[i].height * EditorZoom) / 100) + "px";
                  _Outerasset.style.left =
                    Math.round((array[i].x * EditorZoom) / 100) + "px";
                  _Outerasset.style.top =
                    Math.round((array[i].y * EditorZoom) / 100) + "px";
                }
              } else if (array[i].type.toLowerCase() === "video") {
                const _videoDiv = document.getElementById(
                  "Video-" + array[i].AnimationId
                );

                if (_videoDiv) {
                  _videoDiv.style.width =
                    Math.round((array[i].width * EditorZoom) / 100) + "px";
                  _videoDiv.style.height =
                    Math.round((array[i].height * EditorZoom) / 100) + "px";
                  _videoDiv.style.left =
                    Math.round((array[i].x * EditorZoom) / 100) + "px";
                  _videoDiv.style.top =
                    Math.round((array[i].y * EditorZoom) / 100) + "px";
                }
              } else if (_Outerasset && _Innerasset) {
                _Outerasset.style.width =
                  Math.round((array[i].width * EditorZoom) / 100) + "px";
                _Outerasset.style.height =
                  Math.round((array[i].height * EditorZoom) / 100) + "px";
                _Outerasset.style.left =
                  Math.round((array[i].x * EditorZoom) / 100) + "px";
                _Outerasset.style.top =
                  Math.round((array[i].y * EditorZoom) / 100) + "px";
                _Innerasset.style.width =
                  Math.round((array[i].width * EditorZoom) / 100) + "px";
                _Innerasset.style.height =
                  Math.round((array[i].height * EditorZoom) / 100) + "px";
                _Innerasset.style.left =
                  Math.round((array[i].x * EditorZoom) / 100) + "px";
                _Innerasset.style.top =
                  Math.round((array[i].y * EditorZoom) / 100) + "px";
              }
            }
            // check = true;
          } else {
            array[i].x = array[i].originalX;
          }
        }
      }

      // show/hide character after restart...
      if (
        array[i].startPositionOnTimeline <= count &&
        array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
      ) {
        if (isPlayClicked) {
          if (array[i].player) {
            if (!SoundPlaying) setSoundPlaying(true);
          }
        } else {
          if (array[i].player) {
            if (!SoundPlaying) setSoundPlaying(true);
          }
        }
        if (!array[i].player) {
          array[i].isStartTalkingInTimeline = true;
          array[i].player = true;
          array[i].Animate = true;
          if (array[i].type.toLowerCase() === "props") {
            lottiePlayerForProps(array[i]);
          } else lottiePlayer(array[i]);
          // startAgainLottie(array[i])
          // change = true;
          if (array[i].type !== "audio") {
            await showAsset(`Outer-${array[i].AnimationId}`);
          }
          // else {
          //   // if (!SoundPlaying)
          //   //   setSoundPlaying(true)
          // }

          if (array[i].type === "Video") {
            const _VideoPlayer = document.getElementById(
              "Video-" + array[i].AnimationId
            );
            const isVideoPlaying = (video) =>
              !!(
                video.currentTime > 0 &&
                !video.paused &&
                !video.ended &&
                video.readyState > 2
              );
            if (!isVideoPlaying(_VideoPlayer)) {
              _VideoPlayer.volume = array[i].volume;
              let ms =
                (count - array[i].startPositionOnTimeline) * onePxEquivalent;
              var sec = (ms / 1000).toFixed(1);
              if (_VideoPlayer && isPlayClicked) {
                _VideoPlayer.currentTime = sec;
                _VideoPlayer.play();
              }
            }

            // if (!SoundPlaying) {
            //   setSoundPlaying(true);
            // }
          }
        }
      } else {
        if (array[i].player) {
          array[i].isStartTalkingInTimeline = true;
          array[i].player = false;
          array[i].Animate = false;
          // startAgainLottie(array[i])
          if (array[i].type !== "audio") {
            await hideAsset(`Outer-${array[i].AnimationId}`);
          } else {
            //if(array[i].Audio)
          }
          // else {
          //   if (SoundPlaying)
          //     setSoundPlaying(false)
          // }

          if (array[i].type === "Video") {
            const _VideoPlayer = document.getElementById(
              "Video-" + array[i].AnimationId
            );
            _VideoPlayer.pause();
            // if (SoundPlaying) {
            //   setSoundPlaying(false);
            // }
          }
          // change = true;
        }
      }

      if (_StartPositionOnTimeline === array[i].startPositionOnTimeline) {
        array[i].isStartTalkingInTimeline = true;
      }

      // Voices: a trimmed voice stops at its end, and no voice plays outside its block on the
      // timeline (TTSTrimStart / TTSTrimEnd, see the character's Voice settings).
      if (
        array[i].TTSName &&
        array[i].Audio &&
        array[i].Audio.paused === false &&
        Number(array[i].midTransitionWidths) > 0 &&
        (count < _StartPositionOnTimeline ||
          count > _StartPositionOnTimeline + Number(array[i].midTransitionWidths))
      ) {
        array[i].Audio.pause();
      }

      if (
        _StartPositionOnTimeline == count &&
        array[i].TTSName != "" &&
        array[i].TTSName
      ) {
        array[i].StartTimer = undefined;
        Timer = 0;
        array[i].isStopTalkingInTimeline = true;
        //console.log("Stop Talking condition equal");

        stopTalking(array[i].JSONValue, array[i]);
        // change = true;
      } else if (
        array[i].TTSName != "" &&
        array[i].TTSName &&
        _StartPositionOnTimeline <= count &&
        _StartPositionOnTimeline + array[i].midTransitionWidths >= count
      ) {
        if (array[i].isPlaying == false) {
          // How far into the voice the play head is (ms), from where the voice starts on the
          // timeline. (Before: worked out from leftover values and could start the voice at the
          // wrong word after a stop or a drag.)
          var _diff = Math.max(0, (Number(count) - voiceStartPx(array[i])) * onePxEquivalent);
          array[i].StartTimer = undefined;

          if (array[i].TTSName && !array[i].Audio.src) {
            array[i].Audio = new Audio(
              authenticationData.ApiBaseURL + "/" + array[i].TTSPath
            );
          }

          // A trimmed voice starts TTSTrimStart seconds into its file.
          const _trimStart = Number(array[i].TTSTrimStart) || 0;
          const _voiceSec = _diff / 1000 + _trimStart;
          if (isFinite(_voiceSec) && Math.abs(array[i].Audio.currentTime - _voiceSec) > 0.05) {
            array[i].Audio.currentTime = _voiceSec;
          }

          const _playingNow = playingRef.current;
          if (_playingNow && array[i].Audio.paused) {
            array[i].Audio.play();
          } else if (!_playingNow && !array[i].Audio.paused) {
            // (StartAudioTime is where the voice starts on the timeline, also used by the video
            // export: it is no longer overwritten here.)
            array[i].Audio.pause();
          }

          var _find_Talk_Month = array[i].JSONValue.assets[1].layers.find(
            (x) => x.nm === "Mouth_Talk"
          );

          if (!_find_Talk_Month) {
            if (array[i].JSONValue.assets.find((x) => x.nm == "Mouth_Comp")) {
              _find_Talk_Month = array[i].JSONValue.assets
                .find((x) => x.nm == "Mouth_Comp")
                .layers.find((y) => y.nm == "Mouth_Talk");
            } else if (
              array[i].JSONValue.assets.find((x) => x.id == "comp_11")
            ) {
              _find_Talk_Month = array[i].JSONValue.assets
                .find((x) => x.id == "comp_11")
                .layers.find((y) => y.nm == "Mouth_Talk");
            }
          }

          if (_find_Talk_Month) {
            if (_playingNow) {
              startTalking(array[i].JSONValue, array[i]);
            } else {
              // Stopped, or the play head is being moved by hand: show the talking mouth at the
              // frame that matches the play head, so the mouth follows the play head. At the very
              // end of the timeline the video is over, so the mouth closes.
              const _atEnd = Number(count) >= Number(Tl_TotalTime.width);
              syncMouthToTicker(array[i], !_atEnd, _find_Talk_Month, count);
            }
          }

          // change = true;
          // Only "playing" while the video plays, so pressing Play again starts voice and mouth.
          array[i].isPlaying = _playingNow;
        }
      } else if (array[i].TTSName != "" && array[i].TTSName) {
        if (!isPlayClicked && array[i].Audio) {
          array[i].Audio.currentTime = 0;
          // change = true;
        }

        var _find_Talk_Month = array[i].JSONValue?.assets[1]?.layers?.find(
          (x) => x.nm === "Mouth_Talk"
        );

        if (!_find_Talk_Month) {
          if (array[i].JSONValue.assets.find((x) => x.nm == "Mouth_Comp")) {
            _find_Talk_Month = array[i].JSONValue.assets
              .find((x) => x.nm == "Mouth_Comp")
              .layers.find((y) => y.nm == "Mouth_Talk");
          } else if (array[i].JSONValue.assets.find((x) => x.id == "comp_11")) {
            _find_Talk_Month = array[i].JSONValue.assets
              .find((x) => x.id == "comp_11")
              .layers.find((y) => y.nm == "Mouth_Talk");
          }
        }

        if (_find_Talk_Month) {
          if (!playingRef.current) {
            // Stopped or moving the play head outside the voice: resting mouth, matching frame.
            syncMouthToTicker(array[i], false, _find_Talk_Month, count);
          } else if (!_find_Talk_Month.hd) {
            array[i].isStopTalkingInTimeline = true;
            //console.log("Stop Talking 2");
            stopTalking(array[i].JSONValue, array[i]);
            // change = true;
          }
        }
      }

      if (
        _StartPositionOnTimeline <= count &&
        array[i].startPositionOnTimeline + array[i].widthOnTimeline >= count
      ) {
        //  console.log("enter in blue")
        //  console.log("start pos of blue div on timeline = " + array[i].startPositionOnTimeline)
        //  console.log("counter position = " + count);
        //  console.log("end pos of blue div on timeline = " + array[i].startPositionOnTimeline + array[i].widthOnTimeline )
        //  console.log("width on timeline = " + array[i].widthOnTimeline);

        if (!array[i].player) {
          array[i].player = true;
          if (array[i].type !== "audio") {
            await showAsset(`Outer-${array[i].AnimationId}`);
          } else {
            if (!SoundPlaying) setSoundPlaying(true);
          }

          if (array[i].type === "Video") {
            if (!SoundPlaying) {
              setSoundPlaying(true);
            }
          }
          // change = true;
        }
        if (array[i].type == "Character") {
          // console.log("type char");
          if (array[i].InEffect == "none") {
            if (array[i].AzData == null) {
              if (!array[i].Animate) {
                if (!array[i].StartAudioTime) {
                  array[i].StartAudioTime = count; //* onePxEquivalent;
                }

                array[i].Animate = true;
                // startAgainLottie(array[i])
                // change = true;
              }
            }
          }
          //////////

          if (
            _StartPositionOnTimeline + array[i].startTransitionWidth <
            count
          ) {
            if (array[i].InEffect != "none") {
              if (array[i].AzData == null) {
                if (!array[i].Animate) {
                  array[i].Animate = true;
                  // startAgainLottie(array[i])
                  // change = true;
                }
              } else {
                if (!array[i].startAtoZ) {
                  array[i].startAtoZ = true;
                  // change = true;
                }
              }
            }
          }
        }
        //starttransition(array[i].InEffect, array[i].key)
        //mtrans(count)
        if (array[i].AzData != null) {
          if (
            _StartPositionOnTimeline + array[i].startTransitionWidth <= count &&
            array[i].startPositionOnTimeline +
              array[i].startTransitionWidth +
              array[i].AzData.widthOnTimeline >=
              count
          ) {
            if (!array[i].startAtoZ) {
              array[i].Animate = false;
              // startAgainLottie(array[i])
              array[i].startAtoZ = true;
              // change = true;
            }
          }
          if (
            _StartPositionOnTimeline +
              array[i].startTransitionWidth +
              array[i].AzData.widthOnTimeline <=
            count
          ) {
            if (array[i].startAtoZ) {
              if (array[i].type != "Character") {
                if (array[i].startAtoZ) {
                  array[i].startAtoZ = false;
                  // change = true;
                }
              }

              if (array[i].x != array[i].AzData.x) {
                array[i].x = array[i].AzData.x;
              }
              if (array[i].y != array[i].AzData.y) {
                array[i].y = array[i].AzData.y;
                // change = true;
              }
              if (array[i].width != array[i].AzData.width) {
                array[i].width = array[i].AzData.width;
                // change = true;
              }
              if (array[i].height != array[i].AzData.height) {
                array[i].height = array[i].AzData.height;
                // change = true;
              }

              if (array[i].rotateAngle != array[i].AzData.rotateAngle) {
                array[i].rotateAngle = array[i].AzData.rotateAngle;
                // change = true;
              }
            } else {
              if (array[i].type == "Character") {
                if (!array[i].startAtoZ) {
                  array[i].Animate = true;
                  // startAgainLottie(array[i])
                  // change = true;
                }
              }
            }
          }
        }

        if (
          array[i].startPositionOnTimeline + array[i].startTransitionWidth >=
          count
        ) {
          if (array[i].InEffect != "none") {
            if (array[i].InClass == "") {
              array[i].OutClass = "";
              array[i].InClass = array[i].InEffect;

              if (
                array[i].InEffect == "animated WordByWordFade " ||
                array[i].InEffect == "animated WordByWordAppear "
              ) {
                array[i].text = "";
              }

              // console.log("effect added in class");
              // console.log(array[i])

              //WordByWordAnimation
              // change = true;
            }
          }
        }
        if (
          array[i].startPositionOnTimeline +
            (array[i].startTransitionWidth + array[i].startTransitionWidth) <=
          count
        ) {
          if (array[i].InEffect != "none") {
            if (array[i].InClass != "") {
              array[i].OutClass = "";
              array[i].InClass = "";
              // console.log("effect removed");
              //WordByWordAnimation
              // change = true;
            }
          }
        }
        if (
          array[i].startPositionOnTimeline +
            array[i].widthOnTimeline -
            array[i].endTransitionWidth <=
          count
        ) {
          // if (array[i].type == 'Character') {
          //   if (array[i].AzData) {
          //     array[i].x = array[i].AzData.x;
          //     array[i].y = array[i].AzData.y;
          //     array[i].width = array[i].AzData.width;
          //     array[i].height = array[i].AzData.height;
          //     array[i].rotateAngle = array[i].AzData.rotateAngle;
          //     change = true
          //   }
          // }
          if (array[i].OutEffect != "none") {
            if (array[i].Animate) {
              array[i].Animate = false;
              // startAgainLottie(array[i])
              // change = true;
            }
            if (array[i].startAtoZ) {
              array[i].startAtoZ = false;
              // change = true;
            }

            if (array[i].AzData) {
              if (array[i].x != array[i].AzData.x) {
                array[i].x = array[i].AzData.x;
                // change = true;
              }
              if (array[i].y != array[i].AzData.y) {
                array[i].y = array[i].AzData.y;
                // change = true;
              }
              if (array[i].width != array[i].AzData.width) {
                array[i].width = array[i].AzData.width;
                // change = true;
              }
              if (array[i].height != array[i].AzData.height) {
                array[i].height = array[i].AzData.height;
                // change = true;
              }

              if (array[i].rotateAngle != array[i].AzData.rotateAngle) {
                array[i].rotateAngle = array[i].AzData.rotateAngle;
                // change = true;
              }
            }
            if (array[i].OutClass == "") {
              array[i].InClass = "";
              array[i].OutClass = array[i].OutEffect;
              // change = true;
            }
          }
        }
      }

      //ticker go out of blue character line range
      else if (
        array[i].startPositionOnTimeline + array[i].widthOnTimeline <=
        count
      ) {
        if (array[i].player) {
          array[i].player = false;
          if (array[i].type !== "audio") {
            await hideAsset(`Outer-${array[i].AnimationId}`);
          } else {
            if (SoundPlaying) setSoundPlaying(false);
          }
          if (array[i].type === "Video") {
            if (SoundPlaying) {
              setSoundPlaying(false);
            }
          }
          array[i].InClass = "";
          array[i].OutClass = "";

          if (array[i].InEffect == "animated WordByWordFade ") {
            array[i].text = array[i].originalText;
          }
          // change = true;
        }
        if (array[i].startAtoZ) {
          array[i].startAtoZ = false;
          // change = true;
        }
        if (array[i].Animate) {
          array[i].Animate = false;
          // startAgainLottie(array[i])
          // change = true;
        }
      }
    }
    if (change) {
      setLayersData(array);
    }
    // console.log("== layers data=");
    // console.log(LayersData);
  };

  const startTalking = async (jsondata, value) => {
    const _jsonData = jsondata.assets[1].layers;
    const _jsonData2 = jsondata.assets[0].layers;
    const _jsonData3 = jsondata.layers[0].layers;

    if (jsondata.assets.find((x) => x.nm == "Mouth_Comp")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.nm == "Mouth_Comp"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = false;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = true;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = false;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = true;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_0")) {
      if (
        jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp")
      ) {
        const _jsonDataEditor = jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp").layers;
        for (let i = 0; i < _jsonDataEditor.length; i++) {
          if (_jsonDataEditor[i].nm === "Mouth_Talk") {
            _jsonDataEditor[i].hd = false;
          } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
            _jsonDataEditor[i].hd = true;
          }
        }
      }
    }

    if (jsondata.layers) {
      if (jsondata.layers[0].layers) {
        if (jsondata.layers[0].layers.find((x) => x.nm == "Mouth_Comp")) {
          const _jsonDataEditor = jsondata.layers[0].layers.find(
            (x) => x.nm == "Mouth_Comp"
          ).layers;
          for (let i = 0; i < _jsonDataEditor.length; i++) {
            if (_jsonDataEditor[i].nm === "Mouth_Talk") {
              _jsonDataEditor[i].hd = false;
            } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
              _jsonDataEditor[i].hd = true;
            }
          }
        }
      }
    }

    _jsonData.map((value) => {
      if (value.nm === "Mouth_Talk") {
        value.hd = false;
      } else if (value.nm === "Mouth_Static") {
        value.hd = true;
      }
    });

    _jsonData2.map((value2, index2) => {
      if (_jsonData2.length !== index2) {
        if (value2.nm.toLowerCase() === "mouth") {
          value2.layers.map((value3, index3) => {
            if (value2.layers.length !== index3) {
              if (value3.nm === "Mouth_Talk") {
                value3.hd = false;
              } else if (value3.nm === "Mouth_Static") {
                value3.hd = true;
              }
            }
          });
        }
      }
    });

    _jsonData3.map((value, index) => {
      if (_jsonData3.length !== index) {
        if (value.nm === "Mouth" || value.nm === "mouth") {
          value.layers.map((value2, index2) => {
            if (value.layers.length !== index2) {
              if (value2.nm === "Mouth_Talk") {
                value2.hd = false;
              } else if (value2.nm === "Mouth_Static") {
                value2.hd = true;
              }
            }
          });
        }
      }
    });

    //console.log("Lottie player from Start Talking");

    // if(value.isStartLottiePlayer)
    // {
    //   if(LottiePlayer && LottiePlayer.isPaused)
    //   {
    //     LottiePlayer.animationData = jsondata;
    //   }
    // }
    // else
    // {
    //lottiePlayer(value);
    // }
    let width = 0;
    let trans = TickerRef.current.style.transform;
    if (trans != "") {
      trans = trans.split("(");
      trans = trans[1].split(",");
      trans = trans[0].split("px");
      trans = eval(trans[0]);
      width = trans;
    } else {
      width = 0;
    }
    const get = await lottiePlayer(value);
    let playedtime = width - value.startPositionOnTimeline; //in px
    let jsonTotaltime = get.totalFrames;
    let fm = get.frameRate;
    let ms = (playedtime * onePxEquivalent) / 1000;
    let playedFrame = ms * fm;
    let Playon = null;

    if (playedFrame > jsonTotaltime) {
      while (true) {
        let start = playedFrame - jsonTotaltime;
        if (start < jsonTotaltime) {
          Playon = start;
          break;
        } else {
          playedFrame = start;
        }
      }
    } else {
      Playon = playedFrame;
    }

    // Play only while the video plays; when stopped, hold the frame at the play head.
    if (playingRef.current) get.goToAndPlay(Playon, true);
    else get.goToAndStop(Playon, true);
  };

  const stopTalking = async (jsondata, value) => {
    const _jsonData = jsondata.assets[1].layers;
    const _jsonData2 = jsondata.assets[0].layers;
    const _jsonData3 = jsondata.layers[0].layers;

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = true;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = false;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_11")) {
      const _jsonDataEditor = jsondata.assets.find(
        (x) => x.id == "comp_11"
      ).layers;
      for (let i = 0; i < _jsonDataEditor.length; i++) {
        if (_jsonDataEditor[i].nm === "Mouth_Talk") {
          _jsonDataEditor[i].hd = true;
        } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
          _jsonDataEditor[i].hd = false;
        }
      }
    }

    if (jsondata.assets.find((x) => x.id == "comp_0")) {
      if (
        jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp")
      ) {
        const _jsonDataEditor = jsondata.assets
          .find((x) => x.id == "comp_0")
          .layers.find((y) => y.nm == "Mouth_Comp").layers;
        for (let i = 0; i < _jsonDataEditor.length; i++) {
          if (_jsonDataEditor[i].nm === "Mouth_Talk") {
            _jsonDataEditor[i].hd = true;
          } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
            _jsonDataEditor[i].hd = false;
          }
        }
      }
    }

    if (jsondata.layers) {
      if (jsondata.layers[0].layers) {
        if (jsondata.layers[0].layers.find((x) => x.nm == "Mouth_Comp")) {
          const _jsonDataEditor = jsondata.layers[0].layers.find(
            (x) => x.nm == "Mouth_Comp"
          ).layers;
          for (let i = 0; i < _jsonDataEditor.length; i++) {
            if (_jsonDataEditor[i].nm === "Mouth_Talk") {
              _jsonDataEditor[i].hd = true;
            } else if (_jsonDataEditor[i].nm === "Mouth_Static") {
              _jsonDataEditor[i].hd = false;
            }
          }
        }
      }
    }

    for (let i = 0; i <= _jsonData.length - 1; i++) {
      if (_jsonData[i].nm === "Mouth_Talk") {
        _jsonData[i].hd = true;
      } else if (_jsonData[i].nm === "Mouth_Static") {
        _jsonData[i].hd = false;
      }
    }

    for (let i = 0; i <= _jsonData2.length - 1; i++) {
      if (_jsonData2[i].nm == "Mouth" || _jsonData2[i].nm == "mouth") {
        for (let j = 0; j <= _jsonData2[i].layers.length - 1; j++) {
          if (_jsonData2[i].layers[j].nm === "Mouth_Talk") {
            _jsonData2[i].layers[j].hd = true;
          } else if (_jsonData2[i].layers[j].nm === "Mouth_Static") {
            _jsonData2[i].layers[j].hd = false;
          }
        }
      }
    }

    for (let i = 0; i < _jsonData3.length - 1; i++) {
      if (_jsonData3[i].nm === "Mouth" || _jsonData3[i].nm === "mouth") {
        for (let j = 0; j <= _jsonData3[i].layers.length - 1; j++) {
          if (_jsonData3[i].layers[j].nm === "Mouth_Talk") {
            _jsonData3[i].layers[j].hd = true;
          } else if (_jsonData3[i].layers[j].nm === "Mouth_Static") {
            _jsonData3[i].layers[j].hd = false;
          }
        }
      }
    }

    // Lottie Player for a character
    //console.log("Lottie player from Stop Talking");
    //lottiePlayer(value);

    let width = 0;
    let trans = TickerRef.current.style.transform;
    if (trans != "") {
      trans = trans.split("(");
      trans = trans[1].split(",");
      trans = trans[0].split("px");
      trans = eval(trans[0]);
      width = trans;
    } else {
      width = 0;
    }
    const get = await lottiePlayer(value);
    let playedtime = width - value.startPositionOnTimeline; //in px
    let jsonTotaltime = get.totalFrames;
    let fm = get.frameRate;
    let ms = (playedtime * onePxEquivalent) / 1000;
    let playedFrame = ms * fm;
    let Playon = null;

    if (playedFrame > jsonTotaltime) {
      while (true) {
        let start = playedFrame - jsonTotaltime;
        if (start < jsonTotaltime) {
          Playon = start;
          break;
        } else {
          playedFrame = start;
        }
      }
    } else {
      Playon = playedFrame;
    }
    // Play only while the video plays; when stopped, hold the frame at the play head.
    if (playingRef.current) get.goToAndPlay(Playon, true);
    else get.goToAndStop(Playon, true);
  };

  /** Shows a character at the frame that matches play head position `px`, without playing. */
  const showCharacterAt = (value, px) => {
    const anim = Lottie.getRegisteredAnimations().find((a) => a.name === value.AnimationId);
    if (!anim || !(anim.totalFrames > 0)) return;
    const seconds = ((Number(px) - (Number(value.startPositionOnTimeline) || 0)) * onePxEquivalent) / 1000;
    const frame = Math.max(0, seconds * anim.frameRate) % anim.totalFrames;
    anim.goToAndStop(frame, true);
  };

  /**
   * While stopped or moving the play head by hand: talking mouth inside the voice block, resting
   * mouth outside it, at the frame that matches the play head. The animation is only reloaded
   * when the mouth changes between talking and resting; otherwise it just jumps to the frame.
   */
  const syncMouthToTicker = (value, talk, mouthLayer, px) => {
    if (!value.JSONValue) return;
    if (talk && mouthLayer.hd) {
      startTalking(value.JSONValue, value);
    } else if (!talk && !mouthLayer.hd) {
      value.isStopTalkingInTimeline = true;
      stopTalking(value.JSONValue, value);
    } else {
      showCharacterAt(value, px);
    }
  };

  const lottiePlayer = async (value, onLoad) => {
    try {
      if (!value.JSONValue) {
        if (value.character_FilePath != undefined) {
          const resp = await fetch(
            assetUrl(authenticationData.ApiBaseURL, value.character_FilePath)
          );
          value.JSONValue = await resp.json();
        }
      }

      const data = Lottie.getRegisteredAnimations();

      data.map((LottieData) => {
        if (LottieData.name == value.AnimationId) {
          Lottie.destroy(value.AnimationId);
        }
      });
      //debugger;
      let _svg = document.getElementById("Loader" + value.AnimationId);

      const get = Lottie.loadAnimation({
        container: _svg,
        name: value.AnimationId,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: value.JSONValue,
        rendererSettings: {
          preserveAspectRatio: "xMidYMin slice",
          viewBoxOnly: true,
          progressiveLoad: true,
        },
      });

      if (value.type != "AnimatedText") {
        let width = 0;
        let trans = TickerRef.current.style.transform;
        if (trans != "") {
          trans = trans.split("(");
          trans = trans[1].split(",");
          trans = trans[0].split("px");
          trans = eval(trans[0]);
          width = trans;
        } else {
          width = 0;
        }
        //const get = await lottiePlayer(value);
        let playedtime = width - value.startPositionOnTimeline; //in px
        let jsonTotaltime = get.totalFrames;
        let fm = get.frameRate;
        let ms = (playedtime * onePxEquivalent) / 1000;
        let playedFrame = ms * fm;
        let Playon = null;

        if (playedFrame > jsonTotaltime) {
          while (true) {
            let start = playedFrame - jsonTotaltime;
            if (start < jsonTotaltime) {
              Playon = start;
              break;
            } else {
              playedFrame = start;
            }
          }
        } else {
          Playon = playedFrame;
        }
        if (playingRef.current) get.goToAndPlay(Playon, true);
        else get.goToAndStop(Playon, true);
      }
      return get;
      //debugger;
      // if (onLoad) {
      //   get.goToAndStop(get.totalFrames - 200, true);
      // }
    } catch (ex) {}
  };

  const ForEmergencyLottiePlayer = async (value) => {
    try {
      if (!value.JSONValue) {
        if (value.character_FilePath != undefined) {
          const resp = await fetch(
            assetUrl(authenticationData.ApiBaseURL, value.character_FilePath)
          );
          value.JSONValue = await resp.json();
        }
      }

      const data = Lottie.getRegisteredAnimations();
      data.map((LottieData) => {
        if (LottieData.name == value.AnimationId) {
          Lottie.destroy(value.AnimationId);
        }
      });

      let _svg;
      if (value.type.toLowerCase() === "props")
        _svg = document.getElementById("Canvas-" + value.AnimationId);
      else _svg = document.getElementById("Loader" + value.AnimationId);

      const get = Lottie.loadAnimation({
        container: _svg,
        name: value.AnimationId,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: value.JSONValue,
        rendererSettings: {
          preserveAspectRatio: "xMidYMin slice",
          viewBoxOnly: true,
          progressiveLoad: true,
        },
      });

      return get;
    } catch (ex) {}
  };

  const lottiePlayerForProps = async (value) => {
    if (!value.JSONValue) {
      const resp = await fetch(
        authenticationData.ApiBaseURL + "/" + value.AnimationPath
      );
      value.JSONValue = await resp.json();
    }

    let _props = document.getElementById("Canvas-" + value.AnimationId);
    //debugger;
    if (_props) {
      const data = Lottie.getRegisteredAnimations();
      data.map((LottieData) => {
        if (LottieData.name == value.AnimationId) {
          Lottie.destroy(value.AnimationId);
        }
      });

      const get = Lottie.loadAnimation({
        container: _props,
        name: value.AnimationId,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: value.JSONValue,
        rendererSettings: {
          preserveAspectRatio: "xMidYMin slice",
          viewBoxOnly: true,
          progressiveLoad: true,
        },
      });

      // if (isPlayClicked) {
      //   setLottiePlayerAutoPlay(true);

      // } else {
      //   setLottiePlayerAutoPlay(false);
      //   get.goToAndStop(400, true);

      // }
    }
  };

  useEffect(() => {
    LayersData.map(async (value) => {
      if (value.originalX) {
        value.x = value.originalX;
      }
      if (value.originalY) {
        value.y = value.originalY;
      }

      //temp fix for scale
      const _Outerasset = document.getElementById(`Outer-${value.AnimationId}`);
      if (_Outerasset) {
        _Outerasset.style.transform = `rotate(${value.rotateAngle}deg) scale(1)`;
      }

      //this if statement fixes new tweens for old templates
      if (!value.originalOpacity) {
        value.originalOpacity = 1;
      }
      value.opacity = value.originalOpacity;
      resetOpacity(value);
      if (value.type !== "Video") {
        // Huge fix for tweens
        // if (
        //   value.startPositionOnTimeline + value.startTransitionWidth <
        //     TickerPosition &&
        //   value.startPositionOnTimeline + value.widthOnTimeline > TickerPosition
        // )
        if (
          value.startPositionOnTimeline < TickerPosition &&
          value.startPositionOnTimeline + value.widthOnTimeline > TickerPosition
        ) {
          const _lottieValue = await ForEmergencyLottiePlayer(value);
          if (_lottieValue) {
            let playedtime = TickerPosition - value.startPositionOnTimeline; //in px
            let jsonTotaltime = _lottieValue.totalFrames;
            let fm = _lottieValue.frameRate;
            let ms = (playedtime * onePxEquivalent) / 1000;
            let playedFrame = ms * fm;
            let Playon = null;

            if (playedFrame > jsonTotaltime) {
              while (true) {
                let start = playedFrame - jsonTotaltime;
                if (start < jsonTotaltime) {
                  Playon = start;
                  break;
                } else {
                  playedFrame = start;
                }
              }
            } else {
              Playon = playedFrame;
            }
            value.CurrentFrame = Playon;
            _lottieValue.goToAndStop(Playon, true, value.AnimationId);
            // setCurrentFrame(Playon);
          }
          if (value.startPositionOnTimeline > TickerPosition) {
            _lottieValue.goToAndStop(0, true, value.AnimationId);
            value.CurrentFrame = 0;
            // setCurrentFrame(0);
          }
        }
      } else {
        if (
          value.startPositionOnTimeline <= TickerPosition &&
          value.startPositionOnTimeline + value.widthOnTimeline >=
            TickerPosition
        ) {
          const _videoplayer = document.getElementById(
            "Video-" + value.AnimationId
          );
          if (_videoplayer) {
            let ms =
              (TickerPosition - value.startPositionOnTimeline) *
              onePxEquivalent;
            var sec = (ms / 1000).toFixed(1);
            _videoplayer.currentTime = sec;
            //console.log("Video currentTime ", _videoplayer.currentTime);
          }
        }
      }
    });
  }, [TickerPosition, LayersData]);

  function step(timestamp) {
    if (start === null) {
      start = timestamp;
      StartPoint = TickerState;
    }
    var elapsed = timestamp - start;

    if (previousTimeStamp !== timestamp) {
      const calc = StartPoint + elapsed / onePxEquivalent;
      let string = JSON.stringify(calc);
      string = string.split(".")[0];
      if (eval(string) !== TickerPlay) {
        const count = Math.min(string, Tl_TotalTime.width);
        TickerRef.current.style.transform = `translate(${count}px, 0px)`;
        TickerPlay = count;

        Check(count);
      }
    }

    let ms =
      onePxEquivalent * Tl_TotalTime.width - onePxEquivalent * StartPoint;
    if (elapsed < ms) {
      if (Ids != null) {
        previousTimeStamp = timestamp;
        const id = window.requestAnimationFrame(step);
        Ids = id;
      }
    } else {
      window.cancelAnimationFrame(Ids);
      Ids = null;
      setCanvasDisplay(true);
      start = null;
    }
  }

  // useInterval(
  //   () => {
  //     //let CurrentWidth = TickerPosition + (60 / onePxEquivalent)
  //     if (startval == null) {
  //       startval = TickerState
  //     }
  //     startval = startval + 1
  //     TickerRef.current.style.transform = `translate(${startval}px, 0px)`
  //     Check(startval)
  //     // setTickerPosition({
  //     //   width: CurrentWidth,
  //     // })
  //     // TickerPlay = CurrentWidth
  //     if (Tl_TotalTime.width - 1 <= startval) {
  //       //setcurrentCursorTime(msToTime((CurrentWidth) * onePxEquivalent))
  //       //setPlaying(false)
  //       setCanvasDisplay('block')
  //       //startval = null
  //       // setTickerPosition({
  //       //   time: calculateTimeByWidth(CurrentWidth),
  //       //   width: CurrentWidth
  //       // })
  //     }
  //   },
  //   isPlaying ? onePxEquivalent : null,
  // )

  const handleTimelineTimerInsideClick = (e) => {
    let SL = Scroll.current.scrollLeft;
    let px = e.pageX;

    if (e.target.className != "") {
      let width = px - 306 + SL + 11;
      setTickerPosition(width);
      setTickerState(width);
      setClick_TickerPosition(width);

      Timer = width; //* onePxEquivalent;
      mtrans(width, width);
    }
    reasign("");
  };

  // workingWorker.addEventListener('message', ({ data }) => {
  //   //TickerPlay = data.count
  // });

  const scrollFun2 = (e) => {
    if (e.deltaY > 0) {
      let scrollTop =
        document.getElementsByClassName("mediaStyleWrapper")[0].scrollTop;
      let scrollLeft =
        document.getElementsByClassName("mediaStyleWrapper")[0].scrollLeft;
      document
        .getElementsByClassName("mediaStyleWrapper")[0]
        .scroll(scrollLeft, scrollTop);
      document
        .getElementsByClassName("layerPanelWrapperScroll")[0]
        .scroll(0, scrollTop);
    } else {
      let scrollTop =
        document.getElementsByClassName("mediaStyleWrapper")[0].scrollTop;
      let scrollLeft =
        document.getElementsByClassName("mediaStyleWrapper")[0].scrollLeft;
      document
        .getElementsByClassName("mediaStyleWrapper")[0]
        .scroll(scrollLeft, scrollTop);
      document
        .getElementsByClassName("layerPanelWrapperScroll")[0]
        .scroll(0, scrollTop);
    }
  };

  const mtrans = (TickerPosition, lastX) => {
    if (lottieRef.current != null) {
      //console.log("BLAAAA", lottieRef.current.currentFrame);
    }

    //console.log("dragger moved here");
    const array = Array.from(LayersData);
    // debugger
    setIsPlayClicked(false);
    if (array.length > 0) {
      array.forEach((element) => {
        isStartLottiePlayer = false;
        if (element.type == "Character" && element.TTSName !== "") {
          let tickerPositionInEffect =
            TickerPosition - element.startPositionOnTimeline;

          Check(TickerPosition);
          element.isPlaying = false;
        }

        if (element.type == "AnimatedText") {
          element.endTimeOfAnimatedText = undefined;
        }
      });
    }
    setTickerPosition(TickerPosition);
    let ms = T_parent.current.scrollLeft + lastX; //* onePxEquivalent;
    if (ms >= 0) {
      Timer = ms;
    } else {
      Timer = 0;
    }
    let check = false;
    // debugger
    for (let i = 0; i < array.length; i++) {
      let aToZStart = array[i].startPositionOnTimeline;
      if (TickerPosition < aToZStart) {
        if (array[i].originalX) {
          array[i].x = array[i].originalX;
        }
        if (array[i].originalY) {
          array[i].y = array[i].originalY;
        }
        if (array[i].type !== "basicShape") {
          if (array[i].originalWidth) {
            array[i].width = array[i].originalWidth;
          }
          if (array[i].originalHeight) {
            array[i].height = array[i].originalHeight;
          }
        }

        if (array[i].originalOpacity) {
          array[i].opacity = array[i].originalOpacity;
        }

        if (array[i].originalRotateAngle) {
          array[i].rotateAngle = array[i].originalRotateAngle;
        }
        if (array[i].originalFontSize) {
          if (array[i].type == "text") {
            array[i].fontSize = array[i].originalFontSize;
          }
        }
        if (
          array[i].type == "text" &&
          array[i].InEffect === "animated WordByWordFade "
        ) {
          var txt = array[i].originalText;
          var StrCounter = array[i].WordsArray.length + 1;

          let tickerPositionInEffect =
            TickerPosition - array[i].startPositionOnTimeline;
          let divider = array[i].startTransitionWidth / StrCounter;
          let appendIndex = parseInt(tickerPositionInEffect / divider);
          let _opacity = (tickerPositionInEffect / divider) % 1;
          let $el = document.getElementById(array[i].TextId);
          $el.innerHTML = "";
          for (const j of array[i].WordsArray) {
            let span = document.createElement("span");
            span.style.opacity = 0;
            span.id = j.id;
            if (j.word == "") {
              span.style.opacity = 1;
              span.setAttribute("data-empty", "1");
            }
            span.innerHTML = j.word + j.next;
            $el.appendChild(span);
          }

          for (let j = 0; j < appendIndex - 1; j++) {
            let span = document.getElementById(array[i].WordsArray[j].id);
            if (j == appendIndex - 2) {
              span.style.opacity = _opacity;
            } else {
              span.style.opacity = 1;
            }
          }
        }
      } else {
        if (array[i].OutEffect !== "none") {
          if (array[i].OutEffect === "animated slideOutLeft ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX + array[i].width;
            // let grandWidth =
            //   array[i].startPositionOnTimeline +
            //   (array[i].widthOnTimeline - array[i].endTransitionWidth);
            // if (grandWidth <= TickerPosition) {
            //   let diff = array[i].width / array[i].endTransitionWidth;
            //   let TickerIncr = TickerPosition - grandWidth;
            //   array[i].x = array[i].originalX - diff * TickerIncr;
            //   // check = true;
            // }
          }
          if (array[i].OutEffect === "animated slideOutRight ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX + array[i].width;
            // let grandWidth =
            //   array[i].startPositionOnTimeline +
            //   (array[i].widthOnTimeline - array[i].endTransitionWidth);
            // if (grandWidth <= TickerPosition) {
            //   let diff = array[i].width / array[i].endTransitionWidth;
            //   let TickerIncr = TickerPosition - grandWidth;
            //   array[i].x = array[i].originalX + diff * TickerIncr;
            //   // check = true;
            // }
          }
          if (array[i].OutEffect === "animated slideOutUp ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX - array[i].height;
            // let grandWidth =
            //   array[i].startPositionOnTimeline +
            //   (array[i].widthOnTimeline - array[i].endTransitionWidth);
            // if (grandWidth <= TickerPosition) {
            //   let diff = array[i].height / array[i].endTransitionWidth;
            //   let TickerIncr = TickerPosition - grandWidth;
            //   array[i].y = array[i].originalY - diff * TickerIncr;
            //   // check = true;
            // }
          }
          if (array[i].OutEffect === "animated slideOutDown ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX + array[i].height;
            // let grandWidth =
            //   array[i].startPositionOnTimeline +
            //   (array[i].widthOnTimeline - array[i].endTransitionWidth);
            // if (grandWidth <= TickerPosition) {
            //   let diff = array[i].height / array[i].endTransitionWidth;
            //   let TickerIncr = TickerPosition - grandWidth;
            //   array[i].y = array[i].originalY + diff * TickerIncr;
            //   // check = true;
            // }
          }

          if (array[i].OutEffect === "animated fadeOut ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX + array[i].height;
            // let grandWidth =
            //   array[i].startPositionOnTimeline +
            //   (array[i].widthOnTimeline - array[i].endTransitionWidth);
            // if (grandWidth <= TickerPosition) {
            //   let TickerIncr = TickerPosition - grandWidth;
            //   let opacityPercentage =
            //     1 - TickerIncr / array[i].endTransitionWidth;
            //   array[i].opacity = opacityPercentage;
            //   // check = true;
            // }
          }
          if (array[i].OutEffect === "animated zoomOut ") {
            var totalwidth = array[i].originalX + array[i].height;
            let grandWidth =
              array[i].startPositionOnTimeline +
              (array[i].widthOnTimeline - array[i].endTransitionWidth);
            if (grandWidth <= TickerPosition) {
              let TickerIncr = TickerPosition - grandWidth;

              let percentage = 1 - TickerIncr / array[i].endTransitionWidth;
              if (percentage >= 0) {
                array[i].width = percentage * array[i].originalWidth;
                array[i].height = percentage * array[i].originalHeight;
                array[i].x =
                  array[i].originalX +
                  (array[i].originalWidth - array[i].width) / 2;
                array[i].y =
                  array[i].originalY +
                  (array[i].originalHeight - array[i].height) / 2;
                if (array[i].type == "text") {
                  array[i].fontSize = parseInt(
                    array[i].originalFontSize * percentage
                  );
                }
              }
              // check = true;
            }
          }
        }
        if (array[i].InEffect !== "none") {
          aToZStart =
            array[i].startPositionOnTimeline + array[i].startTransitionWidth;
          if (array[i].InEffect === "animated TypeWriterr ") {
            var totalwidth = array[i].originalX + array[i].width;
            if (
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth >=
              TickerPosition
            ) {
              if (TickerPosition - array[i].startPositionOnTimeline > 0) {
                var txt = array[i].originalText;
                var StrCounter = txt.length + 1;
                // for (let j = 0; j < txt.length; j++) {
                //   if (txt.charAt(j) == "<"
                //     && txt.charAt(j + 1).toLowerCase() == "b"
                //     && txt.charAt(j + 2).toLowerCase() == "r"
                //     && txt.charAt(j + 3).toLowerCase() == ">") {
                //     j = j + 4;
                //   }
                //   else if (txt.charAt(j) == "&"
                //     && txt.charAt(j + 1).toLowerCase() == "n"
                //     && txt.charAt(j + 2).toLowerCase() == "b"
                //     && txt.charAt(j + 3).toLowerCase() == "s"
                //     && txt.charAt(j + 4).toLowerCase() == "p"
                //     && txt.charAt(j + 5).toLowerCase() == ";") {
                //     j = j + 6;
                //   }
                //   StrCounter++;
                // }

                let tickerPositionInEffect =
                  TickerPosition - array[i].startPositionOnTimeline;
                let divider = array[i].startTransitionWidth / StrCounter;
                let appendIndex = parseInt(tickerPositionInEffect / divider);
                let str = "";
                for (let j = 0; j < appendIndex - 1; j++) {
                  if (
                    txt.charAt(j) == "<" &&
                    txt.charAt(j + 1).toLowerCase() == "b" &&
                    txt.charAt(j + 2).toLowerCase() == "r" &&
                    txt.charAt(j + 3).toLowerCase() == ">"
                  ) {
                    str += "<br>";
                    j = j + 4;
                  } else if (
                    txt.charAt(j) == "&" &&
                    txt.charAt(j + 1).toLowerCase() == "n" &&
                    txt.charAt(j + 2).toLowerCase() == "b" &&
                    txt.charAt(j + 3).toLowerCase() == "s" &&
                    txt.charAt(j + 4).toLowerCase() == "p" &&
                    txt.charAt(j + 5).toLowerCase() == ";"
                  ) {
                    str += "&nbsp;";
                    j = j + 6;
                  } else {
                    str += txt.charAt(j);
                  }
                }
                array[i].text = str;
              }
              // check = true;
            }
          }
          if (
            (array[i].InEffect === "animated TextBounce " ||
              array[i].InEffect === "animated TypeWriter ") &&
            CanvasDisplay
          ) {
            var totalwidth = array[i].originalX + array[i].width;
            if (
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth >=
              TickerPosition
            ) {
              if (TickerPosition - array[i].startPositionOnTimeline > 0) {
                var txt = array[i].originalText;
                var StrCounter = txt.length + 1;

                let tickerPositionInEffect =
                  TickerPosition - array[i].startPositionOnTimeline;
                let divider = array[i].startTransitionWidth / StrCounter;
                let appendIndex = parseInt(tickerPositionInEffect / divider);
                let $el = document.getElementById(array[i].TextId);
                if ($el) {
                  $el.innerHTML = "";
                  for (let j = 0; j < array[i].CharactersArray.length; j++) {
                    let obj = array[i].CharactersArray[j];
                    if (obj) {
                      let span = document.createElement("span");
                      span.id = obj.id;
                      if (j < appendIndex - 1) {
                        span.style.opacity = 1;
                        span.setAttribute("data-doneBounce", 1);
                      } else {
                        span.style.opacity = 0;
                      }
                      if (obj.character == "") {
                        span.style.opacity = 1;
                        span.setAttribute("data-empty", "1");
                      } else {
                        span.style.position = "relative";
                      }
                      span.innerHTML = obj.character + obj.next;
                      $el.appendChild(span);
                    }
                  }
                }
              }
            }
          }

          if (array[i].InEffect === "animated WordByWordFade ") {
            var totalwidth = array[i].originalX + array[i].width;
            if (
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth >=
              TickerPosition
            ) {
              if (TickerPosition - array[i].startPositionOnTimeline > 0) {
                var txt = array[i].originalText;
                var StrCounter = array[i].WordsArray.length + 1;

                let tickerPositionInEffect =
                  TickerPosition - array[i].startPositionOnTimeline;
                let divider = array[i].startTransitionWidth / StrCounter;
                let appendIndex = parseInt(tickerPositionInEffect / divider);
                let _opacity = (tickerPositionInEffect / divider) % 1;
                let $el = document.getElementById(array[i].TextId);
                $el.innerHTML = "";
                for (const j of array[i].WordsArray) {
                  let span = document.createElement("span");
                  span.style.opacity = 0;
                  span.id = j.id;
                  if (j.word == "") {
                    span.style.opacity = 1;
                    span.setAttribute("data-empty", "1");
                  }
                  span.innerHTML = j.word + j.next;
                  $el.appendChild(span);
                }

                for (let j = 0; j < appendIndex - 1; j++) {
                  let span = document.getElementById(array[i].WordsArray[j].id);
                  if (j == appendIndex - 2) {
                    span.style.opacity = _opacity;
                  } else {
                    span.style.opacity = 1;
                  }
                }
              }
            }
          }

          if (array[i].InEffect === "animated WordByWordAppear ") {
            var totalwidth = array[i].originalX + array[i].width;
            if (
              array[i].startPositionOnTimeline +
                array[i].startTransitionWidth >=
              TickerPosition
            ) {
              if (TickerPosition - array[i].startPositionOnTimeline > 0) {
                var txt = array[i].originalText;

                var StrCounter = array[i].WordsArray.length + 1;

                let tickerPositionInEffect =
                  TickerPosition - array[i].startPositionOnTimeline;
                let divider = array[i].startTransitionWidth / StrCounter;
                let appendIndex = parseInt(tickerPositionInEffect / divider);

                let _opacity = (tickerPositionInEffect / divider) % 1;
                let $el = document.getElementById(
                  "Text-" + array[i].AnimationId
                );
                if ($el) $el.innerHTML = "";
                for (const j of array[i].WordsArray) {
                  let span = document.createElement("span");
                  span.style.opacity = 0;
                  span.id = j.id;
                  if (j.word == "") {
                    span.style.opacity = 1;
                    span.setAttribute("data-empty", "1");
                  } else {
                    span.style.position = "absolute";
                    span.style.color = "transparent";
                    span.style.textShadow = `0 0 10px ${array[i].textColor}`;
                    span.style.fontSize = array[i].fontSize + 10 + "px";
                  }
                  span.innerHTML = " " + j.word + j.next;
                  $el.appendChild(span);
                }

                for (let j = 0; j < appendIndex - 1; j++) {
                  let span = document.getElementById(array[i].WordsArray[j].id);
                  span.style.opacity = 1;
                  if (j == appendIndex - 2) {
                    //span.style.opacity = _opacity;

                    let fontSize =
                      Number(span.style.fontSize.split("px")[0]) -
                      _opacity * 10;
                    let textShadow = 10 - _opacity * 10;
                    span.style.fontSize = fontSize + "px";
                    span.style.textShadow = `0 0 ${textShadow}px ${array[i].textColor}`;
                  } else {
                    span.style.position = "";
                    span.style.fontSize = "";
                    span.style.textShadow = "";
                    span.style.color = "";
                    span.innerHTML = span.innerHTML.split(" ")[1] + " ";
                  }
                }
              }
            }
          }
          // debugger
          if (array[i].InEffect === "animated slideInRight ") {
            // this is while dragging only
            // var totalwidth = array[i].originalX + array[i].width;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //   TickerPosition
            // ) {
            //   let diff = totalwidth - array[i].originalX;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   array[i].x = totalwidth - startpoint * diff;
            //   // check = true;
            // }
          }
          //this is while dragging
          if (array[i].InEffect === "animated slideInLeft ") {
            //totalwidth is position from where it should start animating
            // var totalwidth =
            //   array[i].originalX -
            //   document.getElementsByClassName("EditorTrackInner")[0]
            //     .clientWidth;
            // var totalwidth = 0 - array[i].width;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //   TickerPosition
            // ) {
            //   let diff = totalwidth - array[i].originalX;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   array[i].x = Math.abs(startpoint * diff) + totalwidth;
            //   // check = true;
            // }
          }

          if (array[i].InEffect === "animated slideInDown ") {
            // for dragging only
            // var totalHeight = array[i].originalY - array[i].height;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //   TickerPosition
            // ) {
            //   let diff = totalHeight - array[i].originalY;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   array[i].y = Math.abs(startpoint * diff) + totalHeight;
            //   // check = true;
            // }
          }

          if (array[i].InEffect === "animated slideInUp ") {
            // For dragging only
            // var totalHeight = array[i].originalY + array[i].height;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //     TickerPosition &&
            //   TickerPosition >= array[i].startPositionOnTimeline
            // ) {
            //   let diff = totalHeight - array[i].originalY;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   array[i].y = totalHeight - startpoint * diff;
            //   // check = true;
            // }
            // console.log("Position");
          }

          if (array[i].InEffect === "animated fadeIn ") {
            // for dragging only
            // var totalHeight = array[i].originalX + array[i].height;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //   TickerPosition
            // ) {
            //   let diff = totalHeight - array[i].originalY;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   let opacityPercentage =
            //     startpoint / array[i].startTransitionWidth;
            //   array[i].opacity = opacityPercentage;
            //   // check = true;
            // }
          }

          if (array[i].InEffect === "animated zoomIn ") {
            // for dragging only
            // var totalHeight = array[i].originalX + array[i].originalHeight;
            // if (
            //   array[i].startPositionOnTimeline +
            //     array[i].startTransitionWidth >=
            //   TickerPosition
            // ) {
            //   //scaling
            //   // let diff = totalHeight - array[i].originalY;
            //   // diff = diff / array[i].startTransitionWidth;
            //   // let startpoint =
            //   //   TickerPosition - array[i].startPositionOnTimeline;
            //   // let scalePercent =
            //   //   startpoint / (array[i].startTransitionWidth - 5);
            //   // array[i].scale = scalePercent;
            //   //console.log("moving dragger");
            //   let diff = totalHeight - array[i].originalY;
            //   diff = diff / array[i].startTransitionWidth;
            //   let startpoint =
            //     TickerPosition - array[i].startPositionOnTimeline;
            //   let percentage = startpoint / array[i].startTransitionWidth;
            //   console.log(percentage);
            //   if (percentage >= 0) {
            //     array[i].width = percentage * array[i].originalWidth;
            //     array[i].height = percentage * array[i].originalHeight;
            //     array[i].x =
            //       array[i].originalX +
            //       (array[i].originalWidth - array[i].width) / 2;
            //     array[i].y =
            //       array[i].originalY +
            //       (array[i].originalHeight - array[i].height) / 2;
            //     if (array[i].type == "text") {
            //       array[i].fontSize = parseInt(
            //         array[i].originalFontSize * percentage
            //       );
            //     }
            //   }
            //array[i].opacity = opacityPercentage;
            // check = true;
          }
        }
        // debugger
        if (array[i].AzData) {
          if (
            TickerPosition >= aToZStart &&
            TickerPosition <= array[i].AzData.widthOnTimeline + aToZStart
          ) {
            let tickerStartpoint = TickerPosition - aToZStart; // array[i].startPositionOnTimeline// + array[i].tranistionStartpoint;
            let aToZEnd = array[i].AzData.widthOnTimeline + aToZStart;
            let azData = array[i].AzData;
            let totalTime = aToZEnd - aToZStart;
            let timePercentage = tickerStartpoint / totalTime;

            if (azData.x != array[i].originalX) {
              if (azData.x > array[i].originalX) {
                let totalXPath = azData.x - array[i].originalX;
                let xPercentage = timePercentage * totalXPath; //azData.x;
                array[i].x = array[i].originalX + xPercentage;
              } else {
                let totalXPath = array[i].originalX - azData.x;
                let xPercentage = timePercentage * totalXPath; //azData.x;)
                array[i].x = array[i].originalX - xPercentage;
              }
            }
            if (azData.y != array[i].originalY) {
              if (azData.y > array[i].originalY) {
                let totalYPath = azData.y - array[i].originalY;
                let yPercentage = timePercentage * totalYPath; // azData.y;
                array[i].y = array[i].originalY + yPercentage;
              } else {
                let totalYPath = array[i].originalY - azData.y;
                let yPercentage = timePercentage * totalYPath; // azData.y;
                array[i].y = array[i].originalY - yPercentage;
              }
            }
            if (azData.width != array[i].originalWidth) {
              if (azData.width > array[i].originalWidth) {
                let totalWidthPath = azData.width - array[i].originalWidth;
                let widthPercentage = timePercentage * totalWidthPath; // azData.y;
                array[i].width = array[i].originalWidth + widthPercentage;
              } else {
                let totalWidthPath = array[i].originalWidth - azData.width;
                let widthPercentage = timePercentage * totalWidthPath; // azData.y;
                array[i].width = array[i].originalWidth - widthPercentage;
              }
            }
            if (azData.height != array[i].originalHeight) {
              if (azData.height > array[i].originalHeight) {
                let totalHeightPath = azData.height - array[i].originalHeight;
                let heightPercentage = timePercentage * totalHeightPath; // azData.y;
                array[i].height = array[i].originalHeight + heightPercentage;
              } else {
                let totalHeightPath = array[i].originalHeight - azData.height;
                let heightPercentage = timePercentage * totalHeightPath; // azData.y;
                array[i].height = array[i].originalHeight - heightPercentage;
              }
            }

            if (azData.rotateAngle != array[i].originalRotateAngle) {
              let AzAngle;
              if (azData.rotateAngle > 180) {
                AzAngle = azData.rotateAngle - 360;
              } else {
                AzAngle = azData.rotateAngle;
              }
              let Angle;
              if (array[i].originalRotateAngle > 180) {
                Angle = array[i].originalRotateAngle - 360;
              } else {
                Angle = array[i].originalRotateAngle;
              }

              if (AzAngle > Angle) {
                let totalrotateAnglePath = AzAngle - Angle;
                let rotatePercentage = timePercentage * totalrotateAnglePath; // azData.y;
                array[i].rotateAngle = Angle + rotatePercentage;
              } else {
                let totalrotateAnglePath = Angle - AzAngle;
                let rotatePercentage = timePercentage * totalrotateAnglePath; // azData.y;
                array[i].rotateAngle = Angle - rotatePercentage;
              }
            }
          } else {
            if (
              array[i].x != array[i].AzData.x ||
              array[i].y != array[i].AzData.y ||
              array[i].width != array[i].AzData.width ||
              array[i].height != array[i].AzData.height ||
              array[i].rotateAngle != array[i].AzData.rotateAngle
            ) {
              array[i].x = array[i].AzData.x;
              array[i].y = array[i].AzData.y;
              array[i].width = array[i].AzData.width;
              array[i].height = array[i].AzData.height;
              array[i].rotateAngle = array[i].AzData.rotateAngle;
            }
          }
        }
      }

      if (
        array[i].type == "text" &&
        array[i].InEffect === "animated TypeWriterr "
      ) {
        if (TickerPosition < array[i].startPositionOnTimeline) {
          document.getElementById(array[i].TextId).innerHTML = "";
        }
        // else if(TickerPosition >= array[i].startPositionOnTimeline + array[i].startTransitionWidth){
        //   array[i].text = array[i].originalText;
        // }
      } else if (
        array[i].type == "text" &&
        (array[i].InEffect === "animated WordByWordFade " ||
          array[i].InEffect === "animated WordByWordAppear ")
      ) {
        if (TickerPosition < array[i].startPositionOnTimeline) {
          if (!array[i].draggedBeforeStartPos) {
            array[i].text = "";
            array[i].draggedBeforeStartPos = true;
            // check = true;
          }
          // document.getElementById(array[i].TextId).innerHTML = '';
        } else {
          if (array[i].draggedBeforeStartPos) {
            array[i].draggedBeforeStartPos = false;
            // check = true;
          }
        }
      }
    }
    if (check) {
      setLayersData(array);
    }
  };

  const reasign = (val) => {
    // debugger
    const array = Array.from(LayersData);
    let check = false;
    for (let i = 0; i < array.length; i++) {
      if (array[i].InEffect !== "none" || array[i].OutEffect !== "none") {
        array[i].x = array[i].originalX;
        array[i].y = array[i].originalY;
        array[i].width = array[i].originalWidth;
        array[i].height = array[i].originalHeight;
        array[i].opacity = array[i].originalOpacity;
        array[i].rotateAngle = array[i].originalRotateAngle;

        if (array[i].rotateAngle == undefined) {
          array[i].rotateAngle = 0;
        }

        if (array[i].type == "text") {
          array[i].fontSize = array[i].originalFontSize;
          if (
            array[i].type == "text" &&
            array[i].InEffect === "animated TypeWriterr " &&
            array[i].startPositionOnTimeline + array[i].startTransitionWidth <=
              val
          ) {
            array[i].text = array[i].originalText;
          }
        }
        if (array[i].InEffect == "animated TextBounce ") {
          for (let j of array[i].CharactersArray) {
            let span = document.getElementById(j.id);
            if (span && !span.getAttribute("data-doneBounce")) {
              span.style.opacity = 1;
              span.style.top = "0px";
            }
          }
        }

        check = true;
      }
    }
    if (check) {
      // setLayersData(array);
    }
  };

  function msTomini(ms) {
    let seconds = (ms / 1000).toFixed(1);
    let minutes = (ms / (1000 * 60)).toFixed(1);
    let hours = (ms / (1000 * 60 * 60)).toFixed(1);
    let days = (ms / (1000 * 60 * 60 * 24)).toFixed(1);
    if (seconds < 60) return seconds + " s";
    else if (minutes < 60) return minutes + " m";
    else if (hours < 24) return hours + " h";
    else return days + " d";
  }

  const totalTimeToMs = (TotalLength) => {
    let timeSplitted = TotalLength.split(":");
    let hours = parseInt(timeSplitted[0]);
    let mins = parseInt(timeSplitted[1]);
    let sec = parseInt(timeSplitted[2]);
    let ms = parseInt(timeSplitted[3]);
    let hoursToMs = hours * 60 * 60 * 1000;
    let minsToMs = mins * 60 * 1000;
    let secToMs = sec * 1000;
    return hoursToMs + minsToMs + secToMs + ms;
  };

  return (
    <div className="tm-parent">
      <div className="tm_parentInsider style-1" ref={Scroll}>
        <div
          className="timelineTimerWrapper"
          style={{ width: TimelineWidth + "px" }}
          ref={T_parent}
        >
          <Draggable
            bounds="parent"
            onStart={(e, data) => {
              if (Ids != null) {
                setCanvasDisplay(true);
              }
              setTickerStart(true);
              mtrans(data.x);
            }}
            onDrag={(e, data) => {
              setIsPlayClicked(false);

              mtrans(data.x, data.lastX);
            }}
            onStop={(e, data) => {
              TickerPlay = data.x;
              setTickerState(data.x);
              setTickerStart(false);
              setClick_TickerPosition(data.x);
              reasign(`${data.x}`);
              //reasign()
            }}
            axis={"x"}
            default={{
              width: 24,
              height: "100%",
            }}
            position={{
              x: TickerState,
              y: 0,
            }}
          >
            <div
              className="timeline-cursor-head"
              id={"tickerHead"}
              ref={TickerRef}
              style={{ zIndex: "1000", top: "-3px" }}
            >
              {" "}
              <div>
                <svg
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  height="24px"
                  viewBox="0 0 24 24"
                  enableBackground="new 0 0 24 24"
                >
                  <path
                    fill="#444242"
                    d="M21.6,0C22.9,0,24,1.1,24,2.4v9.4c0,0.4-0.2,0.7-0.4,1L13,23.6c-0.6,0.6-1.5,0.6-2.1,0L0.4,12.8
                c-0.3-0.3-0.4-0.6-0.4-1V2.4C0,1.1,1.1,0,2.4,0H21.6z"
                  />
                </svg>
                <span className="tooltiptext">
                  {msToTime(Timer * onePxEquivalent)}
                </span>{" "}
              </div>
              <div className="timeline-cursor-bottom" role="presentation"></div>
            </div>
          </Draggable>

          {/* scale start from here */}

          {slides.map((value, index) => {
            if (value.IsActive) {
              if (!value.scaleEnd) {
                value.scaleEnd = 1160;
              }
              //this setState causes some problem.
              if (Tl_TotalTime.width !== value.scaleEnd) {
                setTl_TotalTime({ ...Tl_TotalTime, width: value.scaleEnd });
              }

              return (
                <div
                  key={index}
                  className="timelineTimerInsider"
                  onClick={handleTimelineTimerInsideClick}
                >
                  <Rnd
                    default={{
                      x: 0,
                      y: 0,
                      width: value.scaleEnd,
                      height: 27,
                    }}
                    size={{
                      width: value.scaleEnd,
                      height: 27,
                    }}
                    onClick={handleTimelineTimerInsideClick}
                    className="tm-resize"
                    disableDragging={true}
                    style={{
                      background:
                        "linear-gradient(to bottom, rgba(155, 178, 242, 0.1), rgba(98, 123, 224, 0.15))",
                    }}
                    enableResizing={{
                      top: false,
                      right: true,
                      bottom: false,
                      left: false,
                      topRight: false,
                      bottomRight: false,
                      bottomLeft: false,
                      topLeft: false,
                    }}
                    onResizeStop={(e, direction, ref, delta, position) => {
                      // let width = Tl_TotalTime.width + delta.width;
                      // let time = calculateTimeByWidth(width);

                      let _scaleEnd = value.scaleEnd + delta.width;
                      let _smallTime = calculateTimeByWidth(_scaleEnd);

                      if (totalTimeToMs(_smallTime) > 300000) {
                        _scaleEnd = calculateWidthByDuration("00:05:00:000");
                        _smallTime = "00:05:00:000";
                        swal(
                          "5 Minutes per slide limit reached.",
                          "Slide is reduced to 5 minutes automatically.",
                          "warning"
                        );
                      }
                      setPrevious_TlTotalTime({
                        width: Tl_TotalTime.width,
                        time: Tl_TotalTime.time,
                      });

                      setTl_TotalTime({
                        time: _smallTime,
                        width: _scaleEnd,
                      });

                      const array = Array.from(slides);

                      array[index].SmallTime = msTomini(
                        totalTimeToMs(_smallTime)
                      );
                      array[index].LayerData = LayersData;
                      array[index].offsetWidth = ref.offsetWidth;
                      array[index].isResized = true;
                      array[index].scaleEnd =
                        array[index].scaleEnd + delta.width;
                      array[index].TotalLength =
                        calculateTimeByWidth(_scaleEnd);

                      setslides(array);
                    }}
                  >
                    <span className="tmScalePosition"></span>

                    <div className="Scale">
                      <ScaleUnits
                        unitWidth={props.unitWidth}
                        perUnitMS={props.perUnitMS}
                        count={getScaleUnitArray(scaleLength)}
                      />
                    </div>
                  </Rnd>
                </div>
              );
            }
          })}

          {/* objects start from here */}

          <div
            className="mediaStyleWrapper"
            style={{ width: "100%" }}
            id="MediaLayersWrapper"
            onScroll={(event) => scrollFun2(event)}
          >
            <SortableList
              seteditableObject={seteditableObject}
              key={"SortableL-1"}
              timelineZoomVal={timelineZoomVal}
              setRedoLayer={setRedoLayer}
              UndoLayer={UndoLayer}
              setUndoLayer={setUndoLayer}
              clone={clone}
              items={ReverseLayer}
              calculateTimeByWidth={calculateTimeByWidth}
              LayersData={LayersData}
              setLayersData={setLayersData}
              T_parent={T_parent}
              setCanvasDisplay={setCanvasDisplay}
              ChangeCount={ChangeCount}
              setChangeCount={setChangeCount}
              onePxEquivalent={onePxEquivalent}
              calculateWidthByDuration={calculateWidthByDuration}
              tickerPosition={TickerPosition}
              lottiePlayer={LottiePlayer}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;

const SortableList = ({
  setRedoLayer,
  UndoLayer,
  setUndoLayer,
  items,
  calculateTimeByWidth,
  LayersData,
  setLayersData,
  clone,
  ChangeCount,
  setChangeCount,
  setCanvasDisplay,
  T_parent,
  seteditableObject,
  onePxEquivalent,
  calculateWidthByDuration,
  tickerPosition,
  lottiePlayer,
}) => {
  const { setShowSubMenu } = useContext(TickerContext);

  // Drag either edge of a character's voice block to cut the start or the end of its speech
  // (see Utils/voiceBarTrim.js). The block follows the mouse; the change is saved on release.
  const [voiceTip, setVoiceTip] = useState(null); // { key, text }
  const startVoiceTrim = (e, key, edge) => {
    e.stopPropagation(); // not a drag of the whole character bar
    e.preventDefault();
    const layer = (LayersData || []).find((l) => l.key === key);
    const block = document.getElementById("div_TTS" + key);
    if (!layer || !block) return;
    const x0 = e.clientX;
    let last = null;
    const preview = (clientX) => {
      last = trimVoiceBar(layer, edge, clientX - x0, onePxEquivalent);
      if (!last) return;
      block.style.width = last.midTransitionWidths + "px";
      block.style.left = last.div_TTS_Left;
      setVoiceTip({ key, text: voiceTrimLabel({ ...layer, ...last }) });
    };
    const move = (ev) => preview(ev.clientX);
    const up = (ev) => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseup", up);
      preview(ev.clientX);
      setVoiceTip(null);
      if (!last || Math.abs(ev.clientX - x0) < 1) return;
      const stack = [...(UndoLayer || [])];
      stack.push(clone ? clone(LayersData) : JSON.parse(JSON.stringify(LayersData)));
      if (stack.length > 10) stack.shift();
      setUndoLayer(stack);
      setRedoLayer([]);
      const changes = last;
      setLayersData(
        LayersData.map((l) => {
          if (l.key !== key) return l;
          // l.Audio can be a plain copy after Undo / copy-paste (see Utils/voiceAudio.js).
          if (typeof HTMLMediaElement !== "undefined" && l.Audio instanceof HTMLMediaElement && !l.Audio.paused) l.Audio.pause();
          return { ...l, ...changes, isPlaying: false };
        })
      );
      setChangeCount(ChangeCount + 1);
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseup", up);
  };
  var animationPanel = false;
  var animationPanelType = "";
  const handleTransitionClick = (
    event,
    transitionPosition,
    key,
    currentTransition,
    value
  ) => {
    // debugger

    animationPanel = true;
    animationPanelType = transitionPosition;

    // seteditableObject({
    //   openAnimation: true,
    // });
    let target = event.target;
    if (!target.className.includes("timelineTransition")) {
      target = event.target.offsetParent;
    }
    var offsets = target.getBoundingClientRect();
    var updatedOffset = JSON.parse(JSON.stringify(offsets));
    updatedOffset.top = offsets.top - 253;
    updatedOffset.transitionPosition = transitionPosition;
    updatedOffset.layerKey = key;
    updatedOffset.currentTransition = currentTransition;
    //setShowSubMenu(updatedOffset);
  };
  const { authenticationData } = useContext(AuthContext);

  const stripClick = (key) => {
    const array = Array.from(LayersData);
    for (var i = 0; i < array.length; i++) {
      if (array[i].key === key) {
        if (animationPanel) {
          seteditableObject({
            showPanel: true,
            editableItem: array[i],
            openAnimation: true,
            animationPanelType: animationPanelType,
          });
        } else {
          seteditableObject({ showPanel: true, editableItem: array[i] });
        }
        animationPanel = false;
        array[i].toolbar = true;
        array[i].Editable = true;
        array[i].showDiv = true;
      } else {
        array[i].toolbar = false;
        array[i].Editable = false;
        array[i].showDiv = false;
      }
    }
    setLayersData(array);
  };

  const generateTransitionIcon = (layer) => {
    if (layer.InEffect !== "none" && layer.InEffect !== "") {
      return (
        <div style={{ marginTop: "6px" }}>
          <span className="material-icons" style={{ fontSize: "16px" }}>
            animation
          </span>
        </div>
      );
    }
    if (layer.OutEffect !== "none" && layer.OutEffect !== "") {
      <div style={{ marginTop: "6px" }}>
        <span className="material-icons" style={{ fontSize: "16px" }}>
          animation
        </span>
      </div>;
    }
  };
  useEffect(()=>{
    console.log("in list .........")
  },[LayersData])
  return (
    <>
      {items.map((value, index) => (
        <React.Fragment key={index}>
          <div key={value.key.toString()} className="MediaLayerStrip">
            {value.layerlock === true && (
              <>
                <div
                  style={{
                    position: "absolute",
                    width: value.widthOnTimeline,
                    height: "30px",
                    background: "#ffffff7a",
                    display: "inline-block",
                    top: 0,
                    left: value.startPositionOnTimeline,
                    zIndex: 1,
                    textAlign: "center",
                  }}
                >
                  <div
                    className="material-icons"
                    style={{
                      cursor: "not-allowed",
                      position: "absolute",
                      top: "2px",
                    }}
                  >
                    lock
                  </div>
                </div>

                <div
                  id="main_div_of_layer"
                  style={{
                    position: "absolute",
                    width: value.widthOnTimeline,
                    height: "30px",
                    background: value.bgColor,
                    display: "inline-block",
                    top: 0,
                    left: value.startPositionOnTimeline,
                    cursor: "not-allowed",
                    opacity: value.opc,
                  }}
                >
                  {value.InEffect == "none" && (
                    <div
                      style={{
                        width: "40px",
                        height: "30px",
                        position: "absolute",
                      }}
                    >
                      <div
                        className="timelineTransition"
                        onClick={(event) => {
                          handleTransitionClick(
                            event,
                            "start",
                            value.key,
                            value.InEffect,
                            value
                          );
                        }}
                      >
                        <div className="timelineDraggerSlit"></div>
                        <div
                          className="LayerLeftHandleItemText"
                          title="Click to change effect"
                        >
                          <div style={{ marginTop: "6px" }}>
                            <span
                              className="material-icons"
                              style={{ fontSize: "16px" }}
                            >
                              motion_photos_off
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {value.InEffect != "none" && (
                    <div
                      style={{
                        //this should be dynamic
                        width: "40px",
                        height: "30px",
                        position: "absolute",
                      }}
                    >
                      <div
                        className="timelineTransition"
                        onClick={(event) => {
                          handleTransitionClick(
                            event,
                            "start",
                            value.key,
                            value.InEffect,
                            value
                          );
                        }}
                      >
                        <div className="timelineDraggerSlit"></div>
                        <div
                          className="LayerLeftHandleItemText"
                          title="Click to change effect"
                        >
                          {generateTransitionIcon(value)}
                        </div>
                      </div>
                    </div>
                  )}

                  {value.OutEffect == "none" && (
                    <div
                      style={{
                        width: "40px",
                        height: "30px",
                        position: "absolute",
                        right: "0px",
                      }}
                    >
                      <div
                        className="timelineTransition"
                        onClick={(event) => {
                          handleTransitionClick(
                            event,
                            "start",
                            value.key,
                            value.InEffect,
                            value
                          );
                        }}
                      >
                        <div
                          className="timelineDraggerSlit"
                          style={{ right: "0px" }}
                        ></div>
                        <div
                          className="LayerLeftHandleItemText"
                          title="Click to change effect"
                        >
                          <div style={{ marginTop: "6px" }}>
                            <span
                              className="material-icons"
                              style={{ fontSize: "16px" }}
                            >
                              motion_photos_off
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {value.OutEffect !== "none" && (
                    <div
                      style={{
                        // width: value.endTransitionWidth + "px",
                        width: "40px",
                        height: "30px",
                        position: "absolute",
                        right: "0px",
                      }}
                    >
                      <div className="timelineTransition">
                        <div
                          className="LayerLeftHandleItemText"
                          style={{ cursor: "not-allowed" }}
                        >
                          {value.OutEffect}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}

            {value.layerlock === false && (
              <>
                {value.type !== "Video" && (
                  <>
                    <Rnd
                      key={"Slr" + value.key}
                      bounds="parent"
                      onClick={() => {
                        stripClick(value.key);
                      }}
                      default={{
                        x: 0,
                        y: 0,
                        width: value.widthOnTimeline,
                        height: 30,
                      }}
                      size={{
                        width: value.widthOnTimeline,
                        height: 30,
                      }}
                      position={{
                        x: value.startPositionOnTimeline,
                        y: 0,
                      }}
                      enableResizing={{
                        top: false,
                        right: true,
                        bottom: false,
                        left: true,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false,
                      }}
                      style={{
                        background: value.bgColor,
                        opacity: value.opc,
                        cursor: "grab",
                      }}
                      dragAxis="x"
                      onDragStart={() => {
                        if (Ids != null) {
                          setCanvasDisplay(true);
                        }
                        let stack = [...UndoLayer];
                        const array = Array.from(items)
                        let PrevArray = clone(array.reverse());
                        console.log('UndoLayer 4', UndoLayer)
                        console.log('stack 4', stack)
                        if (stack.length < 10) {
                          console.log('i am in if onDragStart 4 setUndoLayer' )

                          stack.push(PrevArray);
                          setUndoLayer(stack);
                          setRedoLayer([]);
                        } else {
                          console.log('i am in else onDragStart 7 setUndoLayer' )

                          stack.shift();
                          stack.push(PrevArray);
                          setUndoLayer(stack);
                          setRedoLayer([]);
                        }
                      }}
                      onDragStop={(e, data) => {
                        //debugger;
                        const array = Array.from(items);
                        var _marginLeft = 0;

                        if (
                          document.getElementById("div_TTS" + array[index].key)
                        ) {
                          var _div_tts = document.getElementById(
                            "div_TTS" + array[index].key
                          );
                          //  _div_tts.style.position = "sticky"
                          _marginLeft = _div_tts.style.left;
                        }
                        _marginLeft =
                          _marginLeft === 0
                            ? 0
                            : parseFloat(_marginLeft.split("px")[0]);

                        if (
                          array[index].type.toLowerCase() === "character" &&
                          array[index].TTSName !== ""
                        ) {
                          array[index].LastStartPositionOnTimeline =
                            data.lastX + _marginLeft;
                          array[index].startTime = calculateTimeByWidth(
                            data.lastX
                          );
                        } else {
                          array[index].LastStartPositionOnTimeline = data.lastX;
                          array[index].startTime = calculateTimeByWidth(
                            data.lastX
                          );
                        }

                        array[index].startPositionOnTimeline = data.lastX;

                        array[index].endTime = calculateTimeByWidth(
                          data.lastX + value.widthOnTimeline
                        );

                        array[index].StartAudioTime =
                          T_parent.current.scrollLeft +
                          data.lastX +
                          _marginLeft; // * onePxEquivalent

                        array[index].StartTimeOfTTS = calculateTimeByWidth(
                          array[index].StartAudioTime
                        );
                        array[index].StartTimer = Timer; // * onePxEquivalent

                        // if(lottiePlayer)
                        // {
                        //   lottiePlayer.goToAndStop(lottiePlayer.totalFrames - 200, true)
                        // }
                        console.log('LayersData timeline', LayersData)

                        array[index].DrapEndAnimatedText = true;
                        console.log('array.reverse() timeline', array)

                        setLayersData(array.reverse());
                        setChangeCount(ChangeCount + 1);

                      }}
                      onResizeStart={(
                        e,
                        dir,
                        refToElement,
                        delta,
                        position
                      ) => {
                        if (Ids != null) {
                          setCanvasDisplay(true);
                        }

                        console.log('UndoLayer', UndoLayer)
                        let stack = [...UndoLayer];
                        console.log('stack', stack)
                        const array = Array.from(items)
                        let PrevArray = clone(array.reverse());
                        // if(UndoLayer.length == stack.length){
                        if ( stack.length < 10) {
                          console.log('i am in if onResizeStart 9 setUndoLayer' )
                          console.log('PrevArray', PrevArray)
                          stack.push(PrevArray);
                          setUndoLayer(stack);
                          setRedoLayer([]);
                        } else {
                          console.log('i am in else onResizeStart 10 setUndoLayer' )
                          
                          stack.shift();
                          stack.push(PrevArray);
                          setUndoLayer(stack);
                          setRedoLayer([]);
                        }
                      // }
                      }}
                      onResize={(e, dir, refToElement, delta, position) => {
                        const array = Array.from(items);

                        // Sound layers: trimming. The left edge moves where the sound starts in
                        // its file by exactly as much as the edge moved (pulling it back out brings
                        // the cut part back, down to the start of the file); the right edge sets
                        // where it stops. The bar cannot be longer than the rest of the file
                        // ("loop" repeats the bar's clip after it). (Before, sound bars could not
                        // be resized at all.)
                        if (array[index].type === "audio") {
                          const l = array[index];
                          let filePx = 0;
                          try {
                            filePx = l.audioTime ? calculateWidthByDuration(String(l.audioTime)) : 0;
                          } catch (err) {
                            filePx = 0;
                          }
                          const { offset, start, width } = trimSoundBar({
                            offset: l.startSound,
                            start: l.startPositionOnTimeline,
                            dir,
                            newStart: position.x,
                            newWidth: refToElement.offsetWidth,
                            filePx: Number.isFinite(filePx) ? filePx : 0,
                          });
                          l.startSound = offset;
                          l.startSoundInSeconds = calculateTimeByWidth(offset);
                          l.startPositionOnTimeline = start;
                          l.LastStartPositionOnTimeline = start;
                          l.widthOnTimeline = width;
                          l.startTime = calculateTimeByWidth(start);
                          l.duration = calculateTimeByWidth(width);
                          l.endTime = calculateTimeByWidth(start + width);
                          l.endTransitionLeft = width - (l.endTransitionWidth || 0);
                          setLayersData(array.reverse());
                          setChangeCount(ChangeCount + 1);
                          return;
                        }

                        // A character with a voice: the bar can now be made shorter than its
                        // voice; the voice is cut to fit the bar (before, the bar jumped back to
                        // the voice's full length). The voice stays where it is on the timeline.
                        if (array[index].type === "Character" && array[index].TTSName) {
                          const l = array[index];
                          const newStart = dir === "left" ? position.x : l.startPositionOnTimeline;
                          const newWidth = refToElement.offsetWidth;
                          const newEnd = newStart + newWidth;
                          let cur = { ...l, startPositionOnTimeline: newStart, widthOnTimeline: newWidth };
                          const vStart = voiceStartPx(l);
                          const vEnd = vStart + (Number(l.midTransitionWidths) || 0);
                          if (vEnd > newEnd) {
                            const c = trimVoiceBar(cur, "right", newEnd - vEnd, onePxEquivalent);
                            if (c) cur = { ...cur, ...c };
                          }
                          if (vStart < newStart) {
                            const c = trimVoiceBar(cur, "left", newStart - vStart, onePxEquivalent);
                            if (c) cur = { ...cur, ...c };
                          }
                          cur.div_TTS_Left = Math.max(0, voiceStartPx(cur) - newStart) + "px";
                          Object.assign(l, cur, {
                            startTime: calculateTimeByWidth(newStart),
                            duration: calculateTimeByWidth(newWidth),
                            endTime: calculateTimeByWidth(newEnd),
                            endTransitionLeft: newWidth - (l.endTransitionWidth || 0),
                          });
                          setLayersData(array.reverse());
                          setChangeCount(ChangeCount + 1);
                          return;
                        }

                        if (dir === "left") {
                          let _prevStartPositionOnTimeline;

                          if (
                            array[index].LastStartPositionOnTimeline ===
                            undefined
                          ) {
                            _prevStartPositionOnTimeline =
                              array[index].LastStartPositionOnTimeline;
                            array[index].LastStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                          } else {
                            _prevStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                            if (array[index].type === "AnimatedText") {
                              array[index].LastStartPositionOnTimeline =
                                position.x;
                            }
                          }

                          array[index].startPositionOnTimeline = position.x;
                          array[index].startTime = calculateTimeByWidth(
                            position.x
                          );
                          array[index].widthOnTimeline =
                            refToElement.offsetWidth;
                          array[index].duration = calculateTimeByWidth(
                            refToElement.offsetWidth
                          );
                          array[index].endTransitionLeft =
                            value.widthOnTimeline - value.endTransitionWidth;

                          array[index].startPositionOnTimeline = position.x;
                          var _div_tts = document.getElementById(
                            "div_TTS" + array[index].key
                          );
                          // _div_tts.style.position = "sticky"
                          if (
                            array[index].LastStartPositionOnTimeline >
                            position.x
                          ) {
                            // _div_tts.style.left = (array[index].LastStartPositionOnTimeline - array[index].startPositionOnTimeline) + 'px';
                            array[index].div_TTS_Left =
                              array[index].LastStartPositionOnTimeline -
                              array[index].startPositionOnTimeline +
                              "px";
                          } else {
                            if (_div_tts.style) {
                              if (_div_tts.style.left != "0px")
                                // _div_tts.style.left = "0px"
                                array[index].div_TTS_Left = "0px";

                              array[index].LastStartPositionOnTimeline =
                                array[index].startPositionOnTimeline;
                            }
                          }

                          if (
                            array[index].TTSWidthOnTimeline >
                            refToElement.offsetWidth
                          ) {
                            array[index].widthOnTimeline =
                              array[index].TTSWidthOnTimeline;
                            array[index].LastStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                            array[index].StartAudioTime =
                              array[index].LastStartPositionOnTimeline;
                            array[index].StartTimeOfTTS = calculateTimeByWidth(
                              array[index].LastStartPositionOnTimeline
                            );
                            // _div_tts.style.left = "0px"
                            array[index].div_TTS_Left = "0px";
                          } else {
                            array[index].widthOnTimeline =
                              refToElement.offsetWidth;
                          }

                          if (
                            array[index].TTSWidthOnTimeline >
                            refToElement.offsetWidth
                          ) {
                            array[index].widthOnTimeline =
                              array[index].TTSWidthOnTimeline;
                          } else {
                            array[index].widthOnTimeline =
                              refToElement.offsetWidth;
                          }
                          array[index].duration = calculateTimeByWidth(
                            array[index].widthOnTimeline
                          );
                          array[index].endTime = calculateTimeByWidth(
                            position.x + refToElement.offsetWidth
                          );
                          console.log('i am in resize seting layerdata' )
                            console.log('array.reverse()', array)

                          setLayersData(array.reverse());
                        } else {
                          var _div_tts = document.getElementById(
                            "div_TTS" + array[index].key
                          );
                          // _div_tts.style.position = "sticky"
                          let _prevStartPositionOnTimeline;
                          if (
                            array[index].LastStartPositionOnTimeline ===
                            undefined
                          ) {
                            _prevStartPositionOnTimeline =
                              array[index].LastStartPositionOnTimeline;
                            array[index].LastStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                          } else {
                            _prevStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                          }

                          array[index].startPositionOnTimeline = position.x;

                          array[index].duration = calculateTimeByWidth(
                            refToElement.offsetWidth
                          );
                          array[index].endTime = calculateTimeByWidth(
                            position.x + refToElement.offsetWidth
                          );
                          array[index].endTransitionLeft =
                            value.widthOnTimeline - value.endTransitionWidth;

                          if (
                            array[index].completeWithOfTTS >
                            refToElement.offsetWidth
                          ) {
                            // _div_tts.style.left = '0px';
                            array[index].div_TTS_Left = "0px";
                            array[index].LastStartPositionOnTimeline =
                              array[index].startPositionOnTimeline;
                            array[index].widthOnTimeline =
                              array[index].completeWithOfTTS;
                          } else {
                            if (
                              array[index].LastStartPositionOnTimeline +
                                array[index].midTransitionWidths >=
                              refToElement.offsetWidth +
                                array[index].startPositionOnTimeline
                            ) {
                              // if (array[index].startPositionOnTimeline >= array[index].LastStartPositionOnTimeline)
                              // {
                              //   array[index].LastStartPositionOnTimeline = array[index].startPositionOnTimeline
                              // }
                              // else
                              // if(array[index].startPositionOnTimeline <= array[index].LastStartPositionOnTimeline)
                              // {
                              var _div_tts = document.getElementById(
                                "div_TTS" + array[index].key
                              );
                              var _Diff =
                                array[index].widthOnTimeline -
                                refToElement.offsetWidth;
                              //array[index].LastStartPositionOnTimeline = array[index].LastStartPositionOnTimeline;
                              // _div_tts.style.left = (array[index].LastStartPositionOnTimeline - array[index].startPositionOnTimeline) + 'px';
                              // array[index].div_TTS_Left = array[index].LastStartPositionOnTimeline - array[index].startPositionOnTimeline + "px";
                              // }
                              array[index].widthOnTimeline =
                                array[index].LastStartPositionOnTimeline +
                                array[index].TTSWidthOnTimeline -
                                array[index].startPositionOnTimeline;

                              array[index].duration = calculateTimeByWidth(
                                array[index].widthOnTimeline
                              );
                              array[index].endTime = calculateTimeByWidth(
                                array[index].startPositionOnTimeline +
                                  array[index].widthOnTimeline
                              );
                            } else {
                              array[index].widthOnTimeline =
                                refToElement.offsetWidth;
                            }

                            // console.log("startPositionOnTimeline", array[index].startPositionOnTimeline)
                            // console.log("LastStartPositionOnTimeline", array[index].LastStartPositionOnTimeline)
                          }

                          // debugger
                          // if(array[index].type === "AnimatedText")
                          // {
                          //   console.log(array[index].widthOnTimeline)
                          //     if(array[index].widthOnTimeline < 465)
                          //     {
                          //       array[index].widthOnTimeline = 465
                          //     }
                          // }
                          console.log("calling");
                          setLayersData(array.reverse());
                        }
                        setChangeCount(ChangeCount + 1);
                      }}
                    >
                      {value.InEffect == "none" && (
                        <div
                          style={{
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "start",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              <div style={{ marginTop: "6px" }}>
                                <span
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  motion_photos_off
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {value.InEffect != "none" && (
                        <div
                          style={{
                            //this should be dynamic
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "start",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              {generateTransitionIcon(value)}
                            </div>
                          </div>
                        </div>
                      )}

                      {value.AzData != null && (
                        <Rnd
                          key={"SlrChild" + value.key}
                          bounds="parent"
                          maxWidth={
                            value.widthOnTimeline -
                            (value.startTransitionWidth +
                              value.endTransitionWidth)
                          }
                          default={{
                            x: value.startTransitionWidth,
                            y: 0,
                            width: value.AzData.widthOnTimeline,
                            height: 30,
                          }}
                          size={{
                            width: value.AzData.widthOnTimeline,
                            height: 30,
                          }}
                          enableResizing={{
                            top: false,
                            right: true,
                            bottom: false,
                            left: false,
                            topRight: false,
                            bottomRight: false,
                            bottomLeft: false,
                            topLeft: false,
                          }}
                          dragAxis="none"
                          style={{ position: "absolute" }}
                          onResizeStop={(
                            e,
                            dir,
                            refToElement,
                            delta,
                            position
                          ) => {
                            const array = Array.from(items);
                            array[index].AzData.widthOnTimeline =
                              refToElement.offsetWidth;
                            setLayersData(array.reverse());
                          }}
                        >
                          <div
                            className="timelineTransition"
                            style={{ background: "#ffffff7d" }}
                          >
                            <div className="LayerLeftHandleItemText">AtoZ</div>
                          </div>
                        </Rnd>
                      )}

                      {value.OutEffect != "none" && (
                        <div
                          style={{
                            // width: value.endTransitionWidth + "px",
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                            right: "0px",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "end",
                                value.key,
                                value.OutEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              <div style={{ marginTop: "6px" }}>
                                <span
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  animation
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {value.OutEffect == "none" && (
                        <div
                          style={{
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                            right: "0px",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "end",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div
                              className="timelineDraggerSlit"
                              style={{ right: "0px" }}
                            ></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              <div style={{ marginTop: "6px" }}>
                                <span
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  motion_photos_off
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {value.TTSName !== "" && (
                        <div
                          id={"div_TTS" + value.key}
                          style={{
                            width: value.midTransitionWidths + "px",
                            height: "30px",
                            position: "absolute",
                            alignItems: "center",
                            left: value.div_TTS_Left
                              ? value.div_TTS_Left
                              : "0px",
                          }}
                        >
                          <div className="Timeline">
                            <div
                              // onClick={Arjad(value)}
                              className="LayerRightHandleText"
                            >
                              {voiceTip && voiceTip.key === value.key
                                ? voiceTip.text
                                : value.TTSName}
                            </div>
                          </div>
                          {["left", "right"].map((edge) => (
                            <div
                              key={edge}
                              className="voiceTrimHandle"
                              title={
                                edge === "left"
                                  ? "Drag to cut the start of the voice"
                                  : "Drag to cut the end of the voice"
                              }
                              onMouseDown={(e) => startVoiceTrim(e, value.key, edge)}
                              onTouchStart={(e) => e.stopPropagation()}
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                position: "absolute",
                                top: 3,
                                bottom: 3,
                                [edge]: 0,
                                width: 8,
                                cursor: "ew-resize",
                                zIndex: 3,
                                borderRadius: 3,
                                background: "rgba(0,0,0,0.28)",
                                borderLeft: edge === "left" ? "2px solid #fff" : undefined,
                                borderRight: edge === "right" ? "2px solid #fff" : undefined,
                              }}
                            />
                          ))}
                        </div>
                      )}
                    </Rnd>
                  </>
                )}

                {value.type == "Video" && (
                  <Rnd
                    key={"Slr" + value.key}
                    onClick={() => {
                      stripClick(value.key);
                    }}
                    bounds="parent"
                    maxWidth={value.VideoActualLength_withTMZoom}
                    default={{
                      x: 0,
                      y: 0,
                      width: value.widthOnTimeline,
                      height: 30,
                    }}
                    size={{
                      width: value.widthOnTimeline,
                      height: 30,
                    }}
                    position={{
                      x: value.startPositionOnTimeline,
                      y: 0,
                    }}
                    enableResizing={{
                      top: false,
                      right: false,
                      bottom: false,
                      left: false,
                      topRight: false,
                      bottomRight: false,
                      bottomLeft: false,
                      topLeft: false,
                    }}
                    style={{
                      background: value.bgColor,
                      opacity: value.opc,
                      cursor: "grab",
                    }}
                    dragAxis="x"
                    onDragStart={() => {
                      if (Ids != null) {
                        setCanvasDisplay(true);
                      }
                      let stack = [...UndoLayer];
                      // items is the timeline's top-first view; undo needs the layer order
                      // (as LayersData). Storing items as it is turned the stacking order upside
                      // down on Undo after moving a video clip.
                      let PrevArray = clone(Array.from(items).reverse());

                      if (stack.length < 10) {
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      } else {

                        stack.shift();
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      }
                    }}
                    onDragStop={(e, data) => {
                      const array = Array.from(items);

                      if (
                        array[index].LastStartPositionOnTimeline === undefined
                      ) {
                        array[index].LastStartPositionOnTimeline =
                          array[index].startPositionOnTimeline;
                      }

                      array[index].startPositionOnTimeline = data.lastX;
                      array[index].startTime = calculateTimeByWidth(data.lastX);
                      array[index].endTime = calculateTimeByWidth(
                        data.lastX + value.widthOnTimeline
                      );
                      setLayersData(array.reverse());
                      setChangeCount(ChangeCount + 1);
                    }}
                    onResizeStart={(e, dir, refToElement, delta, position) => {
                      if (Ids != null) {
                        setCanvasDisplay(true);
                      }
                      let stack = [...UndoLayer];
                      // items is the timeline's top-first view; undo needs the layer order
                      // (as LayersData). Storing items as it is turned the stacking order upside
                      // down on Undo after moving a video clip.
                      let PrevArray = clone(Array.from(items).reverse());

                      if (stack.length < 10) {

                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      } else {

                        stack.shift();
                        stack.push(PrevArray);
                        setUndoLayer(stack);
                        setRedoLayer([]);
                      }
                    }}
                    onResizeStop={(e, dir, refToElement, delta, position) => {
                      const array = Array.from(items);

                      if (dir === "left") {
                        if (
                          array[index].LastStartPositionOnTimeline === undefined
                        ) {
                          array[index].LastStartPositionOnTimeline =
                            array[index].startPositionOnTimeline;
                        }

                        array[index].startPositionOnTimeline = position.x;
                        array[index].startTime = calculateTimeByWidth(
                          position.x
                        );
                        array[index].widthOnTimeline = refToElement.offsetWidth;
                        array[index].duration = calculateTimeByWidth(
                          refToElement.offsetWidth
                        );
                        array[index].endTransitionLeft =
                          value.widthOnTimeline - value.endTransitionWidth;
                        setLayersData(array.reverse());
                      } else {
                        if (
                          array[index].LastStartPositionOnTimeline === undefined
                        ) {
                          array[index].LastStartPositionOnTimeline =
                            array[index].startPositionOnTimeline;
                        }

                        array[index].startPositionOnTimeline = position.x;
                        array[index].widthOnTimeline = refToElement.offsetWidth;
                        array[index].duration = calculateTimeByWidth(
                          refToElement.offsetWidth
                        );
                        array[index].endTime = calculateTimeByWidth(
                          position.x + refToElement.offsetWidth
                        );
                        array[index].endTransitionLeft =
                          value.widthOnTimeline - value.endTransitionWidth;
                        setLayersData(array.reverse());
                      }
                      setChangeCount(ChangeCount + 1);
                    }}
                  >
                    <div>
                      {value.InEffect == "none" && (
                        <div
                          style={{
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              //debugger;
                              handleTransitionClick(
                                event,
                                "start",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              <div style={{ marginTop: "6px" }}>
                                <span
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  motion_photos_off
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {value.InEffect != "none" && (
                        <div
                          style={{
                            //this should be dynamic
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "start",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              {generateTransitionIcon(value)}
                            </div>
                          </div>
                        </div>
                      )}

                      {value.OutEffect != "none" && (
                        <div
                          style={{
                            // width: value.endTransitionWidth + "px",
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                            right: "0px",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "end",
                                value.key,
                                value.OutEffect,
                                value
                              );
                            }}
                          >
                            <div className="timelineDraggerSlit"></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              {generateTransitionIcon(value)}
                            </div>
                          </div>
                        </div>
                      )}

                      {value.OutEffect == "none" && (
                        <div
                          style={{
                            width: "40px",
                            height: "30px",
                            position: "absolute",
                            right: "0px",
                          }}
                        >
                          <div
                            className="timelineTransition"
                            onClick={(event) => {
                              handleTransitionClick(
                                event,
                                "end",
                                value.key,
                                value.InEffect,
                                value
                              );
                            }}
                          >
                            <div
                              className="timelineDraggerSlit"
                              style={{ right: "0px" }}
                            ></div>
                            <div
                              className="LayerLeftHandleItemText"
                              title="Click to change effect"
                            >
                              <div style={{ marginTop: "6px" }}>
                                <span
                                  className="material-icons"
                                  style={{ fontSize: "16px" }}
                                >
                                  motion_photos_off
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </Rnd>
                )}
              </>
            )}
          </div>
        </React.Fragment>
      ))}
    </>
  );
};

function useInterval(callback, delay) {
  const savedCallback = useRef(callback);

  // Remember the latest callback if it changes.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    // Don't schedule if no delay is specified.
    if (delay === null) {
      return;
    }

    const id = setInterval(() => savedCallback.current(), delay);

    return () => clearInterval(id);
  }, [delay]);
}
